<template>
  <div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5">
    <loading v-if="loadingState || loadingState2" />
    <div class="container mt-5">
      <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      <div class="row justify-content-center text-left">
        <div class="col-md-12">
          <h3 v-if="proccess == 'START'" class="Regular pt-2 h0 widthFull">
            <b>Calcolatore preventivi</b>
          </h3>
          <p v-if="proccess == 'START'" class="black mt-0 text-left widthFull">
            Compila i seguenti step. In caso di conferma del preventivo tutti i
            dati inseriti verranno poi utilizzati per generare i documenti
            richiesti per lo sconto in fattura.
          </p>
        </div>
      </div>

      <!--   FORM WIZARD    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      <div class="row justify-content-center pb-5">
        <div
          v-if="proccess == 'START'"
          class="col-md-12 col-lg-12 vaillantCont pt-1 mt-0"
          style="margin-top: 0 !important"
        >
          <form-wizard
            title=""
            subtitle=""
            class="mt-0 pb-2 formp"
            nextButtonText="Avanti >"
            backButtonText="< Indietro"
            finishButtonText="Salva preventivo"
            @on-change="stepIndex"
            :stepSize="stepSize"
            @on-complete="onComplate"
            color="#00337f"
            errorColor="#ff1100"
          >
            <!--   STEP 1 =>  BONUS SELECT    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
            <tab-content
              v-if="3 == 3"
              title="Scegli Bonus"
              icon=""
              :before-change="validateZeroTab"
            >
              <form
                data-vv-scope="form-0"
                class="widthFull"
                autocomplete="qwerqrt2"
              >
                <!-- DIVIDER -->
                <div class="row justify-content-center divider"></div>

                <div class="row justify-content-center pb-4">
                  <!-- TITLE BONUS INFO -->
                  <div class="col-md-12">
                    <h2 class="pb-0 center section-heading">
                      Clicca sull`icona del bonus al quale vuoi aderire.
                    </h2>
                  </div>

                  <!-- BONUS CASA 50 INPUT -->
                  <div class="col-6 col-md-3 pr-2 pl-2">
                    <div
                      class="selectBonusCont pt-5 pb-4 mb-4"
                      v-on:click="setBonus('Bonus Casa 50%')"
                      :class="{ bonusSelected: ecoBonus == 'Bonus Casa 50%' }"
                    >
                      <div
                        class="selectBonusContBack"
                        v-on:click="setBonus('Bonus Casa 50%')"
                      >
                        Se vuoi aderire al
                        <br />Bonus Casa 50% <br />Clicca qui >
                      </div>
                      <img
                        v-if="ecoBonus != 'Bonus Casa 50%'"
                        class="img-fluid widthFull mb-4"
                        src="../../assets/images/50.png"
                      />
                      <img
                        v-else
                        class="img-fluid widthFull mb-4"
                        src="../../assets/images/50w.png"
                      />
                      <h4
                        class="widthFull center black"
                        :class="{ white: ecoBonus == 'Bonus Casa 50%' }"
                      >
                        Bonus Casa
                      </h4>
                    </div>
                  </div>

                  <!-- ECOBONUS 50 INPUT -->
                  <div class="col-6 col-md-3 pr-2 pl-2">
                    <div
                      class="selectBonusCont pt-5 pb-4 mb-4"
                      v-on:click="setBonus('Ecobonus 50%')"
                      :class="{ bonusSelected: ecoBonus == 'Ecobonus 50%' }"
                    >
                      <div
                        class="selectBonusContBack"
                        v-on:click="setBonus('Ecobonus 50%')"
                      >
                        Se vuoi aderire al
                        <br />Ecobonus 50% <br />Clicca qui >
                      </div>
                      <img
                        v-if="ecoBonus != 'Ecobonus 50%'"
                        class="img-fluid widthFull mb-4"
                        src="../../assets/images/50.png"
                      />
                      <img
                        v-else
                        class="img-fluid widthFull mb-4"
                        src="../../assets/images/50w.png"
                      />
                      <h4
                        class="widthFull center black"
                        :class="{ white: ecoBonus == 'Ecobonus 50%' }"
                      >
                        Ecobonus
                      </h4>
                    </div>
                  </div>

                  <!-- ECOBONUS 65 INPUT -->
                  <div class="col-6 col-md-3 pr-2 pl-2">
                    <div
                      class="selectBonusCont pt-5 pb-4 mb-4"
                      v-on:click="setBonus('Ecobonus 65%')"
                      :class="{ bonusSelected: ecoBonus == 'Ecobonus 65%' }"
                    >
                      <div
                        class="selectBonusContBack"
                        v-on:click="setBonus('Ecobonus 65%')"
                      >
                        Se vuoi aderire al
                        <br />Ecobonus 65% <br />Clicca qui >
                      </div>
                      <img
                        v-if="ecoBonus != 'Ecobonus 65%'"
                        class="img-fluid widthFull mb-4"
                        src="../../assets/images/65.png"
                      />
                      <img
                        v-else
                        class="img-fluid widthFull mb-4"
                        src="../../assets/images/65w.png"
                      />
                      <h4
                        class="widthFull center black"
                        :class="{ white: ecoBonus == 'Ecobonus 65%' }"
                      >
                        Ecobonus
                      </h4>
                    </div>
                  </div>

                  <!-- HIDDEN INPUT TO CHOICE -->
                  <div class="col-md-12 mb-3" style="display: none">
                    <div class="group custInput">
                      <input
                        type="text"
                        v-model="ecoBonus"
                        id="ecobonus"
                        name="ecobonus"
                        data-vv-as="ecoBonus"
                        v-validate="{ required: true, max: 63, min: 2 }"
                        :class="{
                          'is-invalid': errors.has('form-0.ecoBonus'),
                          valid: !!ecoBonus,
                        }"
                      />
                    </div>
                  </div>

                  <!-- VALIDATION ERROR -->
                  <div class="col-md-12 mb-3 center">
                    <div v-if="errors.has('form-0.ecobonus')" class="red">
                      <b class="h5 red"
                        >Per procedere devi selezionare una tra le quattro icone
                        sopraindicate.
                      </b>
                    </div>
                  </div>

                  <div class="col-md-12 mb-3">
                    Novatag e KPMG, non si ritengono responsabili per eventuali
                    danni economici derivanti dall.utilizo della piattaforma e
                    dall.informazioni fornite.
                  </div>
                </div>

                <!-- DIVIDER -->
                <div class="row justify-content-center divider"></div>
              </form>
            </tab-content>
            <!--   END STEP 1 =>  BONUS SELECT    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

            <!--   STEP 2 =>   USER, HOUSE DATA   ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
            <tab-content
              v-if="3 == 3"
              title="Dati Cliente"
              icon=""
              :before-change="validateFirstTab"
            >
              <form
                v-if="ecoBonus != 'Superbonus 110%'"
                data-vv-scope="form-1"
                class="widthFull"
                autocomplete="qwerqrt2"
              >
                <div class="row">
                  <!-- TITLE CLIENT INFO -->
                  <div class="col-md-12">
                    <h4 class="widthFull center black">
                      Inserisci i dati del cliente finale
                    </h4>
                  </div>
                  <!-- CLIENT TYPE INPUT ROW 1 -->
                  <div class="col-md-4 mb-3">
                    <div class="group custInput">
                      <select
                        type="text"
                        autocomplete="randomq"
                        class="form-control"
                        v-model="client_type"
                        id="client_type"
                        name="client_type"
                        data-vv-as="Tipologia cliente"
                        v-validate="{ required: true, max: 63, min: 2 }"
                        :class="{
                          'is-invalid': errors.has('form-1.client_type'),
                          valid: !!client_type,
                        }"
                      >
                        <option value="Amministratore di condominio">
                          Condominio (Amministratore)
                        </option>
                        <option value="Persona fisica">Persona fisica</option>
                        <option
                          v-if="ecoBonus != 'Bonus Casa 50%'"
                          value="Partita IVA"
                        >
                          Partita IVA
                        </option>
                      </select>
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="niceInputLabel" for="client_type"
                        >Tipologia cliente</label
                      >
                      <div
                        v-if="errors.has('form-1.client_type')"
                        class="invalid-feedback"
                      >
                        {{ errors.first("form-1.client_type") }}
                      </div>
                    </div>
                  </div>

                  <!-- CLIENT NAME INPUT ROW 1 -->
                  <div class="col-md-4 mb-3">
                    <div class="group custInput">
                      <input
                        type="text"
                        autocomplete="randomq"
                        class="form-control"
                        v-model="clientName"
                        id="clientName"
                        name="clientName"
                        data-vv-as="Nome"
                        v-validate="{ required: true, max: 63, min: 2 }"
                        :class="{
                          'is-invalid': errors.has('form-1.clientName'),
                          valid: !!clientName,
                        }"
                      />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="niceInputLabel" for="clientName"
                        >Nome</label
                      >
                      <div
                        v-if="errors.has('form-1.clientName')"
                        class="invalid-feedback"
                      >
                        {{ errors.first("form-1.clientName") }}
                      </div>
                    </div>
                  </div>
                  <!-- CLIENT LASTNAME INPUT ROW 1 -->
                  <div class="col-md-4 mb-3">
                    <div class="group custInput">
                      <input
                        type="text"
                        autocomplete="randomq"
                        class="form-control"
                        v-model="clientLastname"
                        id="clientLastname"
                        name="clientLastname"
                        data-vv-as="Cognome"
                        v-validate="{ required: true, max: 63, min: 2 }"
                        :class="{
                          'is-invalid': errors.has('form-1.clientLastname'),
                          valid: !!clientLastname,
                        }"
                      />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="niceInputLabel" for="clientLastname"
                        >Cognome</label
                      >
                      <div
                        v-if="errors.has('form-1.clientLastname')"
                        class="invalid-feedback"
                      >
                        {{ errors.first("form-1.clientLastname") }}
                      </div>
                    </div>
                  </div>

                  <!-- CLIENT EMAIL INPUT ROW 1 -->

                  <div class="col-md-4 mb-3">
                    <div class="group custInput">
                      <input
                        type="text"
                        v-model="client_email"
                        class="form-control"
                        id="client_email"
                        name="client_email"
                        ref="client_email"
                        data-vv-as="Email"
                        v-validate="{
                          required: true,
                          email: true,
                          temporaryEmail: true,
                          plusIssueEmail: true,
                          max: 56,
                        }"
                        :class="{
                          'is-invalid': errors.has('form-1.client_email'),
                          valid: !!client_email,
                        }"
                      />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="niceInputLabel" for="client_email"
                        >Email*
                      </label>

                      <div
                        v-if="errors.has('form-1.client_email')"
                        class="invalid-feedback"
                      >
                        {{ errors.first("form-1.client_email") }}
                      </div>
                    </div>
                  </div>

                  <!-- CLIENT phone INPUT ROW 1 -->
                  <div class="col-md-4 mb-3">
                    <div class="group custInput">
                      <input
                        type="text"
                        class="form-control"
                        v-model="client_phone"
                        id="client_phone"
                        name="client_phone"
                        data-vv-as="Telefono"
                        v-validate="{
                          required: false,
                          max: 12,
                          min: 8,
                          regex: /^[0]+/,
                        }"
                        :class="{
                          'is-invalid': errors.has('form-1.client_phone'),
                          valid: !!client_phone,
                        }"
                      />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="niceInputLabel" for="client_phone"
                        >Telefono
                      </label>
                      <div
                        v-if="errors.has('form-1.client_phone')"
                        class="invalid-feedback"
                      >
                        {{ errors.first("form-1.client_phone") }}
                      </div>
                    </div>
                  </div>

                  <!-- CLIENT phone INPUT ROW 1 -->
                  <div class="col-md-4 mb-3">
                    <div class="group custInput">
                      <input
                        type="text"
                        class="form-control"
                        v-model="client_mobile"
                        id="client_mobile"
                        name="client_mobile"
                        data-vv-as="Cellulare"
                        v-validate="{
                          required: true,
                          max: 12,
                          min: 8,
                          regex: /^[3]+/,
                        }"
                        :class="{
                          'is-invalid': errors.has('form-1.client_mobile'),
                          valid: !!client_mobile,
                        }"
                      />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="niceInputLabel" for="client_mobile"
                        >Cellulare *
                      </label>
                      <div
                        v-if="errors.has('form-1.client_mobile')"
                        class="invalid-feedback"
                      >
                        {{ errors.first("form-1.client_mobile") }}
                      </div>
                    </div>
                  </div>

                  <!--
                <div v-if="client_type != 'Amministratore di condominio'" class="col-md-6 mb-3">
                  <div class="group custInput">
                    <select type="text" autocomplete="randomq" class="form-control" v-model="client_ownership" id="client_ownership" name="client_ownership" data-vv-as="Titolo di possesso" v-validate="{required:true, max: 63, min: 2}"
                      :class="{ 'is-invalid': errors.has('form-1.client_ownership'), valid: !!client_ownership }">
                      <option value="Proprietario">Proprietario</option>
                      <option value="Usufruttuario">Usufruttuario</option>
                      <option value="Locatario">Locatario</option>
                      <option value="Promissario acquirente">Promissario acquirente</option>
                      <option value="Familiare convivente del possessore/detentore">Familiare convivente del possessore/detentore</option>
                      <option value="Erede">Erede</option>
                      <option value="Coniuge separato assegnatario">Coniuge separato assegnatario</option>
                      <option value="Socio di cooperativa a proprietà indivisa">Socio di cooperativa a proprietà indivisa</option>
                      <option value="Socio di cooperativa a proprietà divisa">Socio di cooperativa a proprietà divisa</option>
                    </select>
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="niceInputLabel" for="client_ownership">Titolo di possesso</label>
                    <div v-if="errors.has('form-1.client_ownership')" class="invalid-feedback">
                      {{ errors.first("form-1.client_ownership") }}
                    </div>
                  </div>
                </div>


                <!-- SERVICE DATI CATASTALI -->
                  <div
                    v-if="ecoBonus != 'Bonus Casa 50%'"
                    class="col-md-6 mb-3"
                  >
                    <div class="form-check">
                      <div class="group">
                        <label
                          class="form-check-label widthFull black h5"
                          for="usoAbitativo"
                        >
                          Prevalente uso abitativo
                        </label>
                        <div class="form-check form-check-inline mt-2">
                          <label
                            class="form-check-label"
                            v-on:click="usoAbitativo = 1"
                          >
                            <input
                              type="radio"
                              class="form-check-input inline mr-3"
                              v-model="usoAbitativo"
                              v-validate="'required|included:1,0'"
                              value="1"
                              name="usoAbitativo"
                              :class="{
                                'is-invalid': errors.has('form-1.usoAbitativo'),
                              }"
                            /><b>SI</b>
                          </label>
                        </div>
                        <div class="form-check form-check-inline">
                          <label
                            class="form-check-label"
                            v-on:click="usoAbitativo = 0"
                          >
                            <input
                              type="radio"
                              class="form-check-input inline mr-3"
                              v-model="usoAbitativo"
                              value="0"
                              name="usoAbitativo"
                              :class="{
                                'is-invalid': errors.has('form-1.usoAbitativo'),
                              }"
                            /><b>NO</b>
                          </label>
                        </div>
                        <br />
                        <span
                          class="errorMes red"
                          v-show="errors.has('form-1.usoAbitativo')"
                        >
                          Il servizio deve essere accettato oppure rifiutato
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- DIVIDER -->
                  <div class="row justify-content-center divider"></div>

                  <!-- TITLE HOUSE INFO -->
                  <div class="col-md-12">
                    <h4 class="widthFull center black pb-4">
                      Inserisci l'indirizzo dell'immobile
                    </h4>
                  </div>
                  <!-- PROVINCE INPUT ROW 2 -->

                  <div class="col-md-4 mb-3">
                    <div class="group custInput">
                      <select
                        v-model="province"
                        autocomplete="randomy"
                        id="province"
                        name="province"
                        class="form-control"
                        data-vv-as="Provincia"
                        v-validate="{ required: true }"
                        :class="{
                          'is-invalid': errors.has('form-1.province'),
                          valid: !!province,
                        }"
                      >
                        <option disabled value="" selected="selected"></option>
                        <option
                          v-for="province in provincies"
                          :key="province.sigla"
                          v-bind:value="province.sigla"
                        >
                          {{ province.sigla }} - {{ province.provincia }}
                        </option>
                      </select>
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="niceInputLabel" for="province"
                        >Provincia</label
                      >
                      <div v-if="provinciesState">
                        <font-awesome-icon
                          class="loadSpinner"
                          id="loadProvince"
                          icon="spinner"
                          size="1x"
                          pulse
                        />
                      </div>
                      <div
                        v-if="errors.has('form-1.province')"
                        class="invalid-feedback"
                      >
                        {{ errors.first("form-1.province") }}
                      </div>
                    </div>
                  </div>
                  <!-- CITY INPUT ROW 2 -->
                  <div class="col-md-4 mb-3">
                    <div class="group custInput">
                      <span v-if="cityError" class="formError"
                        >Prima scegli Provincia</span
                      >
                      <select
                        class="form-control"
                        autocomplete="randomu"
                        v-model="city"
                        v-on:click="checkProvince"
                        id="city"
                        name="city"
                        data-vv-as="Località"
                        v-validate="{ required: true }"
                        :disabled="citiesState"
                        :class="{
                          'is-invalid': errors.has('form-1.city'),
                          valid: !!city,
                        }"
                      >
                        <option disabled value="" selected="selected"></option>

                        <option
                          v-for="city in cities"
                          :key="city.comune"
                          v-bind:value="{
                            cityistat: city.istat,
                            city: city.comune,
                          }"
                        >
                          {{ city.comune }}
                        </option>
                      </select>

                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="niceInputLabel" for="city">Località</label>

                      <div v-if="citiesState">
                        <font-awesome-icon
                          class="loadSpinner"
                          id="loadCity"
                          icon="spinner"
                          size="1x"
                          pulse
                        />
                      </div>
                      <div
                        v-if="errors.has('form-1.city')"
                        class="invalid-feedback"
                      >
                        {{ errors.first("form-1.city") }}
                      </div>
                    </div>
                  </div>
                  <!-- ZIP INPUT ROW 2 -->
                  <div class="col-md-4 mb-3">
                    <div class="group custInput">
                      <span v-if="zipError" class="formError"
                        >Prima scegli città</span
                      >
                      <select
                        class="form-control"
                        autocomplete="randomi"
                        v-model="zip"
                        v-on:click="checkZip"
                        id="zip"
                        name="zip"
                        data-vv-as="Cap"
                        v-validate="{ required: true }"
                        :disabled="zipsState"
                        :class="{
                          'is-invalid': errors.has('form-1.zip'),
                          valid: !!zip,
                        }"
                      >
                        <option value="" disabled :selected="true"></option>
                        <option
                          v-for="zip in zips"
                          :key="zip.cap"
                          v-bind:value="zip.cap"
                        >
                          {{ zip.cap }}
                        </option>
                      </select>
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="niceInputLabel" for="zip">Cap</label>
                      <div v-if="zipsState">
                        <font-awesome-icon
                          class="loadSpinner"
                          id="loadZips"
                          icon="spinner"
                          size="1x"
                          pulse
                        />
                      </div>
                      <div
                        v-if="errors.has('form-1.zip')"
                        class="invalid-feedback"
                      >
                        {{ errors.first("form-1.zip") }}
                      </div>
                    </div>
                  </div>

                  <!-- ADDRESS INPUT ROW 3 -->
                  <div class="col-md-6 mb-3">
                    <div class="group custInput">
                      <input
                        type="text"
                        autocomplete="randomq"
                        class="form-control"
                        v-model="adress"
                        id="adress"
                        name="adress"
                        data-vv-as="Indirizzo"
                        v-validate="{ required: true, max: 128, min: 5 }"
                        :class="{
                          'is-invalid': errors.has('form-1.adress'),
                          valid: !!adress,
                        }"
                      />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="niceInputLabel" for="adress"
                        >Indirizzo</label
                      >
                      <div
                        v-if="errors.has('form-1.adress')"
                        class="invalid-feedback"
                      >
                        {{ errors.first("form-1.adress") }}
                      </div>
                    </div>
                  </div>
                  <!-- CIVIC INPUT ROW 3 -->
                  <div class="col-md-6 mb-3">
                    <div class="group custInput">
                      <input
                        type="text"
                        autocomplete="randomq"
                        class="form-control"
                        v-model="civic"
                        id="civic"
                        name="civic"
                        data-vv-as="Civico"
                        v-validate="{ required: true, max: 15, min: 1 }"
                        :class="{
                          'is-invalid': errors.has('form-1.civic'),
                          valid: !!civic,
                        }"
                      />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="niceInputLabel" for="civic">Civico</label>
                      <div
                        v-if="errors.has('form-1.civic')"
                        class="invalid-feedback"
                      >
                        {{ errors.first("form-1.civic") }}
                      </div>
                    </div>
                  </div>

                  <!-- DIVIDER -->
                  <div class="row justify-content-center divider"></div>

                  <!--  *********************************************************************************************************************************************************************************** -->
                  <!-- SERVICE DATI CATASTALI *********************************************************************************************************************************************************************************** -->

                  <!-- TITLE HOUSE INFO --
                <div class="col-md-12">
                  <h4 class="widthFull center black pb-0">
                    Dati Catastali
                  </h4>
                  <p class="center">
                    Se offri l'opzione <b>"Visura Catastale"</b> Inserisci il costo per il tuo cliente altrimenti inserisci "0" ( zero )
                  </p>
                </div>
                <!-- PROVINCE INPUT ROW 2 -->

                  <!-- NEW FOR ADD --
                <div class="col-md-6 mb-3" v-if="priceDcast != 0">
                  <div class="group custInput">
                    <input type="text" autocomplete="randomq" class="form-control" @change="formatpriceDcast()" v-model="priceDcast" id="priceDcast" name="priceDcast" data-vv-as="Costo Gestione Pratica ENEA"
                      v-validate="{required:true, max: 63, min: 2}" :class="{ 'is-invalid': errors.has('form-2.priceDcast'), valid: !!priceDcast }">
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="niceInputLabel" for="priceDcast">Costo recupero dei dati catastali dell'immobile</label>
                    <small><b class="yellow">Valore che sarà addebitato al cliente e visualizzato nel preventivo</b></small>
                    <div v-if="errors.has('form-2.priceDcast')" class="invalid-feedback">
                      {{ errors.first("form-2.priceDcast") }}
                    </div>
                  </div>
                </div>
                <!-- END --

                <div class="col-md-6 mb-3">

                  <div class="form-check" v-if="datiCatastali != 0">
                    <div class="group">
                      <label class="form-check-label widthFull black h5" for="datiCatastali">
                        Servizio <b>"Visura Catastale"</b> al costo di €10 +IVA. <small><b class="yellow"> <br />( costo che ti sarà addebitato se accetti il servizio )</b></small>
                      </label>
                      <div class="form-check form-check-inline mt-2">
                        <label class="form-check-label" v-on:click="datiCatastali = 1">
                          <input type="radio" class="form-check-input inline mr-3" v-model="datiCatastali" v-validate="'required|included:1,0'" value="1" name="datiCatastali"
                            :class="{ 'is-invalid': errors.has('form-1.datiCatastali') }"><b>ACCETTO</b>
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <label class="form-check-label" v-on:click="datiCatastali = 0">
                          <input type="radio" class="form-check-input inline mr-3" v-model="datiCatastali" value="0" name="datiCatastali" :class="{ 'is-invalid': errors.has('form-1.datiCatastali') }"><b>NON ACCETTO</b>
                        </label>
                      </div>
                      <br />
                      <span class="errorMes red" v-show="errors.has('form-1.datiCatastali')">
                        Il servizio deve essere accettato oppure rifiutato
                      </span>
                    </div>
                  </div>
                </div>

                <!-- DIVIDER-->
                  <div class="row justify-content-center divider"></div>

                  <!--  *********************************************************************************************************************************************************************************** -->
                  <!--  *********************************************************************************************************************************************************************************** -->
                </div>
              </form>

              <form
                v-else
                data-vv-scope="form-1"
                class="widthFull"
                autocomplete="qwerqrt2"
              >
                <div class="row">
                  <!-- TITLE CLIENT INFO -->
                  <div class="col-md-12">
                    <h4 class="widthFull center black">LISTA DOCUMENTI</h4>
                  </div>
                </div>
              </form>
            </tab-content>
            <!--   STEP 2 =>   USER, HOUSE DATA   ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

            <!--   STEP 3 => PRODUCTS DATA   ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
            <tab-content
              title="Dati Intervento"
              icon=""
              :before-change="validateSecondTab"
            >
              <form
                data-vv-scope="form-2"
                class="widthFull orangeBg"
                autocomplete="qwerqrt3"
              >
                <div class="row justify-content-center">
                  <div class="row justify-content-center divider"></div>

                  <!-- TITLE ROW 1 HOUSE INFO -->
                  <div class="col-md-12">
                    <h4 class="widthFull center black">
                      Inserisci i dati dell'intervento
                    </h4>
                  </div>

                  <!-- Tipo di intervento INPUT -->
                  <div class="col-md-6 mb-3">
                    <div class="group custInput">
                      <select
                        type="text"
                        autocomplete="randomq"
                        class="form-control"
                        v-model="eventType"
                        id="eventType"
                        name="eventType"
                        data-vv-as="Tipo di intervento"
                        v-validate="{ required: true, max: 63, min: 2 }"
                        :class="{
                          'is-invalid': errors.has('form-2.eventType'),
                          valid: !!eventType,
                        }"
                      >
                        <option value="" disabled selected></option>
                        <option value="sostituzione">Sostituzione</option>
                        <option value="Instalazione">
                          Nuova Installazione
                        </option>
                      </select>
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="niceInputLabel" for="eventType"
                        >Tipo di intervento</label
                      >
                      <div
                        v-if="errors.has('form-2.eventType')"
                        class="invalid-feedback"
                      >
                        {{ errors.first("form-2.eventType") }}
                      </div>
                    </div>
                  </div>
                  <!-- Data inizio INPUT
                <div class="col-md-6 mb-3 ">
                  <div class="group custInput">
                    <datepicker :language="it" v-model="eventStartdate" :full-month-name="true" :format="'dd MMMM yyyy'" :monday-first="true" :disabledDates="disabledDatesStart" id="eventStartdate" name="eventStartdate"
                      input-class="form-control dateInput"></datepicker>
                    <input type="text" v-show="false" v-model="eventStartdate" class="form-control" id="eventStartdate" name="eventStartdate" data-vv-as="Data inizio" v-validate="{required:true}"
                      :class="{ 'is-invalid': errors.has('form-2.eventStartdate'), valid: !!eventStartdate }">
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="niceInputLabel" for="eventStartdate">Data inizio</label>
                    <div v-if="errors.has('form-2.eventStartdate')" class="invalid-feedback">
                      {{ errors.first("form-2.eventStartdate") }}
                    </div>
                  </div>
                </div>
                -->
                  <div class="row justify-content-center divider"></div>

                  <!-- TITLE ROW 2 PRODUCTS -->
                  <div class="col-md-12">
                    <h4 class="widthFull center black">
                      Inserisci Beni Significativi
                    </h4>
                  </div>

                  <div class="col-md-12">
                    <div class="widthFull">
                      <!-- PRODUCTS FOR -->
                      <div v-for="(elem, num) in products" class="row" >
                        <!-- PRODUCTS GROUP INPUT -->
                        <div class="col-md-3">
                          <div class="group custInput">
                            <select
                              v-model="elem.group"
                              @change="setGroup(elem.index)"
                              class="form-control"
                              :id="'g' + elem.index"
                              :name="'g' + elem.index"
                              data-vv-as="Gruppo"
                              v-validate="{ required: true, is_not: '' }"
                              :class="{
                                'is-invalid': errors.has(
                                  'form-2.g' + elem.index
                                ),
                                valid: !!elem.group,
                              }"
                            >
                              <template v-if="ecoBonus == 'Ecobonus 50%'">
                                <template v-for="(item,ii) in groups">
                                  <option
                                  :key="ii"
                                    v-if="item.value == 'condensazione' || item.value == 'altroVaillant'"
                                    :value="item.value"
                                    selected="selected"
                                  >
                                    {{ item.name }}
                                  </option>
                                </template>
                              </template>

                              <template v-else-if="ecoBonus == 'Ecobonus 65%'">
                                <template v-for="item in groups">
                                  <option
                                    v-if="item.value != 'tradizionale'"
                                    :value="item.value"
                                    selected="selected"
                                  >
                                    {{ item.name }}
                                  </option>
                                </template>
                              </template>

                              <template v-else>
                                <template v-for="item in groups">
                                  <option
                                    :value="item.value"
                                    selected="selected"
                                  >
                                    {{ item.name }}
                                  </option>
                                </template>
                              </template>
                            </select>

                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="niceInputLabel" for="group"
                              >Scegli gruppo prodotto</label
                            >

                            <div
                              v-if="errors.has('form-2.g' + elem.index)"
                              class="invalid-feedback"
                            >
                              {{ errors.first("form-2.g" + elem.index) }}
                            </div>
                            <h4
                              class="widthFull black pointer m-0"
                              v-on:click="insertProductCode(elem.index)"
                            >
                              <font-awesome-icon
                                v-on:click="insertProductCode(elem.index)"
                                icon="search"
                                size="sm"
                              />
                              <small>o cerca con codice prodotto </small>
                            </h4>
                          </div>
                        </div>
                        <!-- PRODUCT NAME INPUT -->
                        <div class="col-md-5">
                          <div class="group custInput">
                            <select
                              v-if="
                                elem.group != 'ibridi' &&
                                elem.group != 'altroVaillant'
                              "
                              v-model="elem.product"
                              @change="setProduct(elem.index)"
                              class="form-control"
                              v-on:click="checkIfEmpty"
                              :id="'p' + elem.index"
                              :name="'p' + elem.index"
                              data-vv-as="Prodotto"
                              v-validate="{ required: true, is_not: '' }"
                              :class="{
                                'is-invalid': errors.has(
                                  'form-2.p' + elem.index
                                ),
                                valid: !!elem.product,
                              }"
                            >
                              <!-- NORMAL PRODUCTS -->
                              <option
                                v-for="(item, ind) in items[elem.index]"
                                :value="{
                                  index: ind,
                                  name: item.Modello,
                                  serial: item.codice,
                                }"
                              >
                                {{ item.Modello }}
                              </option>
                            </select>

                            <input
                              type="text"
                              v-else-if="elem.group == 'altroVaillant'"
                              v-model="elem.product.name"
                              @change="setProduct(elem.index)"
                              class="form-control"
                              v-on:click="checkIfEmpty"
                              :id="'p' + elem.index"
                              :name="'p' + elem.index"
                              data-vv-as="Prodotto"
                              v-validate="{ required: true, is_not: '' }"
                              :class="{
                                'is-invalid': errors.has(
                                  'form-2.p' + elem.index
                                ),
                                valid: !!elem.product,
                              }"
                            />

                            <select
                              v-else="elem.group == 'ibridi'"
                              v-model="elem.product"
                              @change="setProduct(elem.index)"
                              class="form-control"
                              v-on:click="checkIfEmpty"
                              :id="'p' + elem.index"
                              :name="'p' + elem.index"
                              data-vv-as="Prodotto"
                              v-validate="{ required: true, is_not: '' }"
                              :class="{
                                'is-invalid': errors.has(
                                  'form-2.p' + elem.index
                                ),
                                valid: !!elem.product,
                              }"
                            >
                              <!-- IBRIDE PRODUCTS  CONTAINS 2 PRODUCT-->
                              <option
                                v-for="(item, ind) in items[elem.index]"
                                :value="{
                                  index: ind,
                                  name: item.Modello,
                                  serial: item.codice,
                                }"
                              >
                                {{ item.Modello }}
                                {{ item.ModelloPompaDiCalore }} +
                                {{ item.ModelloCaldaiaACondensazione }}
                              </option>
                            </select>

                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="niceInputLabel" for="product"
                              >Scegli Prodotto</label
                            >

                            <div
                              v-if="
                                errors.has('form-2.p' + elem.index) &&
                                !elem.error
                              "
                              class="invalid-feedback"
                            >
                              {{ errors.first("form-2.p" + elem.index) }}
                            </div>

                            <div v-if="elem.error" class="invalid-feedback">
                              Prima scegli gruppo
                            </div>
                          </div>
                        </div>
                        <!-- PRODUCT QUANTITY INPUT -->
                        <div class="col-md-2 mr-md-0 pr-md-0">
                          <div class="group custInput">
                            <input
                              type="number"
                              v-model="elem.quantity"
                              @change="calcTotalPriceProducts()"
                              class="form-control"
                              :id="'q' + elem.indexCount"
                              min="1"
                              :name="'q' + elem.indexCount"
                              data-vv-as="Quantità"
                              v-validate="{
                                required: true,
                                is_not: '0',
                                min_value: 1,
                                max: 4,
                              }"
                              :class="{
                                'is-invalid': errors.has(
                                  'form-2.q' + elem.indexCount
                                ),
                                valid: !!elem.quantity,
                              }"
                            />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="niceInputLabel" :for="elem.indexCount"
                              >Quantità</label
                            >

                            <div
                              v-if="errors.has('form-2.q' + elem.indexCount)"
                              class="invalid-feedback"
                            >
                              {{ errors.first("form-2.q" + elem.indexCount) }}
                            </div>
                          </div>
                        </div>
                        <!-- PRODUCT PRICE INPUT -->
                        <div class="col-md-2 pl-md-0 ml-md-0">
                          <div class="group custInput">
                            <input
                              type="text"
                              v-model="elem.price"
                              @change="
                                formatPrice(elem.index),
                                  calcTotalPriceProducts()
                              "
                              v-on:keyup="
                                keymonitor($event, elem.index, 'prod')
                              "
                              class="form-control"
                              :id="'i' + elem.indexCount"
                              min="1"
                              :name="'i' + elem.indexCount"
                              data-vv-as="Prezzo"
                              v-validate="{ required: true, is_not: '0' }"
                              :class="{
                                'is-invalid': errors.has(
                                  'form-2.i' + elem.indexCount
                                ),
                                valid: !!elem.price,
                              }"
                            />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label class="niceInputLabel" :for="elem.indexCount"
                              >Prezzo €</label
                            >
                            <small class="widthFull center">
                              (IVA esclusa)
                            </small>
                            <div
                              v-if="errors.has('form-2.i' + elem.indexCount)"
                              class="invalid-feedback"
                            >
                              {{ errors.first("form-2.i" + elem.indexCount) }}
                            </div>
                          </div>
                          <span
                            class="removeProduct pointer"
                            :class="elem.index"
                          >
                            <font-awesome-icon
                              v-if="num != 0"
                              v-on:click="removeProduct(num)"
                              icon="trash-alt"
                              size="lg"
                            />
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- TOTAL PRODUCT PRICE -->
                    <div class="row">
                      <div class="col-md-3 mb-3 text-left pr-4">
                        <span
                          v-on:click="addProduct"
                          class="pointer helper btn btn-secondary"
                        >
                          <font-awesome-icon
                            class="helper pointer addProduct"
                            v-on:click="addProduct"
                            icon="plus-circle"
                            size="1x"
                          />
                          Aggiungi prodotto
                        </span>
                      </div>
                      <div class="col-md-9 mb-3 text-right pr-5 pt-2 black">
                        Totale importo prodotti (IVA esclusa):
                        <span class="Bold">{{ totalProducts }} €</span>
                      </div>
                    </div>

                    <div class="row justify-content-center divider"></div>

                    <!-- ROW 3 TITLE BENI ACCESSORI -->
                    <div class="row">
                      <div class="col-md-12">
                        <h4 class="widthFull center black">
                          Inserisci altri Beni/Accessori opzionali
                        </h4>
                      </div>
                    </div>
                    <!-- ROW 3 FOR -->
                    <div v-for="(elem, num) in accessories" class="row">
                      <!-- INPUT ACCESSORIES TYPE -->
                      <div class="col-md-3">
                        <div class="group custInput">
                          <select
                            v-model="elem.group"
                            @change="setTypeAccessories(elem.index)"
                            class="form-control"
                            :id="'ac' + elem.index"
                            :name="'ac' + elem.index"
                            data-vv-as="accessori opzionali"
                            v-validate="{}"
                            :class="{
                              'is-invalid': errors.has(
                                'form-2.ac' + elem.index
                              ),
                              valid: !!elem.group,
                            }"
                          >
                            <option
                              v-for="item in groupsAccessori"
                              :value="item.value"
                              selected="selected"
                            >
                              {{ item.name }}
                            </option>
                          </select>

                          <span class="highlight"></span>
                          <span class="bar"></span>
                          <label class="niceInputLabel" for="group"
                            >Scegli accessori opzionali</label
                          >

                          <div
                            v-if="errors.has('form-2.ac' + elem.index)"
                            class="invalid-feedback"
                          >
                            {{ errors.first("form-2.ac" + elem.index) }}
                          </div>
                          <h4
                            class="widthFull black pointer m-0"
                            v-on:click="insertAccessoriesCode(elem.index)"
                          >
                            <font-awesome-icon
                              v-on:click="insertAccessoriesCode(elem.index)"
                              icon="search"
                              size="sm"
                            />
                            <small>o cerca con codice accessorio </small>
                          </h4>
                        </div>
                      </div>
                      <!-- INPUT ACCESSORIES -->
                      <div class="col-md-5">
                        <div class="group custInput">
                          <select
                            v-if="elem.group == 'termoregolazione'"
                            v-model="elem.product"
                            @change="setAccessories(elem.index)"
                            class="form-control"
                            v-on:click="checkIfEmpty"
                            :id="'ap' + elem.index"
                            :name="'ap' + elem.index"
                            data-vv-as="Accessorio"
                            v-validate="{ required: elem.group != '' }"
                            :class="{
                              'is-invalid': errors.has(
                                'form-2.ap' + elem.index
                              ),
                              valid: !!elem.product,
                            }"
                          >
                            <option
                              v-for="(item, ind) in itemsAccessories[
                                elem.index
                              ]"
                              :value="{
                                index: ind,
                                name: item.Modello,
                                serial: item.codice,
                              }"
                              selected="selected"
                            >
                              {{ item.Modello }}
                            </option>
                          </select>

                          <input
                            type="text"
                            v-else
                            v-model="elem.product.name"
                            class="form-control"
                            :id="'ap' + elem.index"
                            :name="'ap' + elem.index"
                            data-vv-as="Accessorio"
                            v-validate="{
                              required: elem.group != '',
                              max: 128,
                            }"
                            :class="{
                              'is-invalid': errors.has(
                                'form-2.ap' + elem.index
                              ),
                              valid: !!elem.product.name,
                            }"
                          />

                          <span class="highlight"></span>
                          <span class="bar"></span>
                          <label
                            v-if="elem.group == 'termoregolazione'"
                            class="niceInputLabel"
                            for="product"
                            >Scegli Accessorio</label
                          >
                          <label v-else class="niceInputLabel" for="product"
                            >Inserisci Accessorio</label
                          >

                          <div
                            v-if="
                              errors.has('form-2.ap' + elem.index) &&
                              !elem.error
                            "
                            class="invalid-feedback"
                          >
                            {{ errors.first("form-2.ap" + elem.index) }}
                          </div>

                          <div v-if="elem.error" class="invalid-feedback">
                            Prima scegli tipo
                          </div>
                        </div>
                      </div>
                      <!-- INPUT ACCESSORIES QUANTITY -->
                      <div class="col-md-2 mr-md-0 pr-md-0">
                        <div class="group custInput">
                          <input
                            type="number"
                            v-model="elem.quantity"
                            @change="calcTotalPriceAccessories()"
                            class="form-control"
                            :id="'aq' + elem.indexCount"
                            min="1"
                            :name="'aq' + elem.indexCount"
                            data-vv-as="Quantità"
                            v-validate="{
                              required: elem.group != '',
                              is_not: '0',
                              min_value: 1,
                              max: 4,
                            }"
                            :class="{
                              'is-invalid': errors.has(
                                'form-2.aq' + elem.indexCount
                              ),
                              valid: !!elem.quantity,
                            }"
                          />
                          <span class="highlight"></span>
                          <span class="bar"></span>
                          <label class="niceInputLabel" :for="elem.indexCount"
                            >Quantità</label
                          >

                          <div
                            v-if="errors.has('form-2.aq' + elem.indexCount)"
                            class="invalid-feedback"
                          >
                            {{ errors.first("form-2.aq" + elem.indexCount) }}
                          </div>
                        </div>
                      </div>
                      <!-- INPUT ACCESSORIES PRICE -->
                      <div class="col-md-2 pl-md-0 ml-md-0">
                        <div class="group custInput">
                          <input
                            type="text"
                            v-model="elem.price"
                            @change="
                              formatPriceAccessories(elem.index);
                              calcTotalPriceAccessories();
                            "
                            v-on:keyup="keymonitor($event, elem.index, 'accs')"
                            class="form-control"
                            :id="'ai' + elem.indexCount"
                            min="1"
                            :name="'ai' + elem.indexCount"
                            data-vv-as="Prezzo"
                            v-validate="{
                              required: elem.group != '',
                              is_not: '0',
                            }"
                            :class="{
                              'is-invalid': errors.has(
                                'form-2.ai' + elem.indexCount
                              ),
                              valid: !!elem.price,
                            }"
                          />
                          <span class="highlight"></span>
                          <span class="bar"></span>
                          <label class="niceInputLabel" :for="elem.indexCount"
                            >Prezzo €</label
                          >

                          <small class="widthFull center">
                            (IVA esclusa)
                          </small>

                          <div
                            v-if="errors.has('form-2.ai' + elem.indexCount)"
                            class="invalid-feedback"
                          >
                            {{ errors.first("form-2.ai" + elem.indexCount) }}
                          </div>
                        </div>
                        <span class="removeProduct pointer" :class="elem.index">
                          <!-- v-if="num != 0" -->
                          <font-awesome-icon
                            v-on:click="removeAccessories(num)"
                            icon="trash-alt"
                            size="lg"
                          />
                        </span>
                      </div>
                    </div>

                    <!-- TOTAL ACCESSORIES PRICE -->
                    <div class="row">
                      <div class="col-md-3 mb-3 text-left pr-4">
                        <span
                          v-on:click="addAccessories"
                          class="pointer helper btn btn-secondary"
                        >
                          <font-awesome-icon
                            class="helper pointer addProduct"
                            v-on:click="addAccessories"
                            icon="plus-circle"
                            size="1x"
                          />
                          Aggiungi accessorio
                        </span>
                      </div>
                      <div class="col-md-9 mb-3 text-right pr-5 pt-2 black">
                        Totale importo accessori opzionali (IVA esclusa):
                        <span class="Bold">{{ totalAccessories }} €</span>
                      </div>
                    </div>

                    <div class="row justify-content-center divider"></div>

                    <!--  *********************************************************************************************************************************************************************************** -->
                    <!--  *********************************************************************************************************************************************************************************** -->
                    <!-- PRATICA ENEA -->
                    <div  class="row pt-4">
                      <div class="col-md-12">
                        <h4 class="widthFull center black">Pratica ENEA</h4>
                        <!--<p class="center widthFull Bold">
                          <b
                            >Solo per impianti aventi potenza nominale del
                            focolare &#8804; 100 kW</b
                          >
                        </p>-->
                      </div>

                      <div class="col-md-6 mb-3">
                        <div class="group custInput">
                          <input
                            type="text"
                            autocomplete="randomq"
                            class="form-control"
                            @change="formatpriceEnea()"
                            v-model="priceEnea"
                            id="priceEnea"
                            name="priceEnea"
                            data-vv-as="Costo Gestione Pratica ENEA"
                            v-validate="{ required: true, max: 63, min: 2 }"
                            :class="{
                              'is-invalid': errors.has('form-2.priceEnea'),
                              valid: !!priceEnea,
                            }"
                          />
                          <span class="highlight"></span>
                          <span class="bar"></span>
                          <label class="niceInputLabel" for="priceEnea"
                            >Costo Gestione Pratica ENEA</label
                          >
                          <small>Valore che sarà addebitato al cliente </small>
                          <div
                            v-if="errors.has('form-2.priceEnea')"
                            class="invalid-feedback"
                          >
                            {{ errors.first("form-2.priceEnea") }}
                          </div>
                        </div>
                      </div>

                      <div v-if="NoEnea" class="col-md-6 mb-3">
                        <div class="form-check">
                          <div class="group">
                            <label
                              class="form-check-label widthFull black h5"
                              for="datiCatastali"
                            >
                              Servizio di redazione e invio pratica ENEA ad un
                              costo di €50 +IVA ( costo che ti sarà addebitato
                              se accetti il servizio )
                            </label>
                            <div class="form-check form-check-inline mt-2">
                              <label
                                class="form-check-label"
                                v-on:click="enea = 1"
                              >
                                <input
                                  type="radio"
                                  class="form-check-input inline mr-3"
                                  v-model="enea"
                                  v-validate="'required|included:1,0'"
                                  value="1"
                                  name="enea"
                                  :class="{
                                    'is-invalid': errors.has('form-2.enea'),
                                  }"
                                /><b>ACCETTO</b>
                              </label>
                            </div>
                            <div class="form-check form-check-inline">
                              <label
                                class="form-check-label"
                                v-on:click="enea = 0"
                              >
                                <input
                                  type="radio"
                                  class="form-check-input inline mr-3"
                                  v-model="enea"
                                  v-validate="'required|included:1,0'"
                                  value="0"
                                  name="enea"
                                  :class="{
                                    'is-invalid': errors.has('form-2.enea'),
                                  }"
                                /><b>NON ACCETTO</b>
                              </label>
                            </div>
                            <br />
                            <span
                              class="errorMes red"
                              v-show="errors.has('form-2.enea')"
                            >
                              Il servizio deve essere accettato oppure rifiutato
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- sdghsd hsdf-->

                      <!--  *********************************************************************************************************************************************************************************** -->
                      <!--  *********************************************************************************************************************************************************************************** -->
                    </div>

                    <div class="row justify-content-center divider"></div>

                    <div class="row pt-4">
                      <div class="col-md-12">
                        <h4 class="widthFull center black">
                          Installazione e Posa in Opera
                        </h4>
                      </div>

                      <div class="col-md-6 mb-3">
                        <div class="group custInput">
                          <input
                            type="text"
                            autocomplete="randomq"
                            class="form-control"
                            @change="formatpriceWork()"
                            v-model="priceWork"
                            id="priceWork"
                            name="priceWork"
                            data-vv-as="Importo installazione/posa in opera"
                            v-validate="{ required: true, max: 63, min: 2 }"
                            :class="{
                              'is-invalid': errors.has('form-2.priceWork'),
                              valid: !!priceWork,
                            }"
                          />
                          <span class="highlight"></span>
                          <span class="bar"></span>
                          <label class="niceInputLabel" for="priceWork"
                            >Importo installazione/posa in opera ( IVA esclusa
                            )</label
                          >
                          <div
                            v-if="errors.has('form-2.priceWork')"
                            class="invalid-feedback"
                          >
                            {{ errors.first("form-2.priceWork") }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row justify-content-center divider"></div>
                    <!-- WORK PRICE INPUT -->
                    <div class="row pt-2">
                      <div class="col-md-12 mb-3 text-right pr-5 pt-2 black">
                        Totale importo (IVA esclusa):
                        <span class="Bold">
                          {{
                            (
                              parseFloat(
                                totalProducts.replace(".", "").replace(",", ".")
                              ) +
                              parseFloat(
                                totalAccessories
                                  .replace(".", "")
                                  .replace(",", ".")
                              ) +
                              parseFloat(
                                priceWork.replace(".", "").replace(",", ".")
                              ) +
                              parseFloat(
                                priceEnea.replace(".", "").replace(",", ".")
                              ) +
                              parseFloat(
                                priceDcast.replace(".", "").replace(",", ".")
                              )
                            ).toFixed(2) | formatNumber
                          }}
                          €
                        </span>
                      </div>
                    </div>

                    <!--  IVA CHOICE

                  iva_altri_oneri: 0.22,
                  iva_accessori_lavoro: 0.1,
                  iva_age_extra: 0.22,
                  iva_age_lavoro: 0.1,
                  iva_age_accessori: 0.1,

                -->

                    <div class="row justify-content-center divider"></div>

                    <div
                      v-if="getProfile.reg_forfettario != 'si'"
                      class="row justify-content-center pt-2 pb-4"
                    >
                      <div class="col-md-12 mb-3 center">
                        <h4 class="widthFull center black">
                          Riepilogo aliquote IVA
                        </h4>
                      </div>

                      <div class="col-md-6 mb-3 center">
                        <h5 class="widthFull text-left black">
                          Beni significativi, quota concorrente accessori e
                          manodopera
                        </h5>
                      </div>
                      <div class="col-md-2 mb-3 center">
                        <select
                          class="form-control"
                          v-model="iva_age_lavoro"
                          id="iva_age_lavoro"
                          name="iva_age_lavoro"
                          data-vv-as="Beni significativi, quota concorrente accessori e manodopera"
                          v-validate="{ required: true }"
                          :class="{
                            'is-invalid': errors.has('form-2.iva_age_lavoro'),
                            valid: !!iva_age_lavoro,
                          }"
                        >
                          <option
                            v-if="
                              client_type != 'Partita IVA' && usoAbitativo == 1
                            "
                            value="0.10"
                          >
                            10%
                          </option>
                          <option
                            v-if="
                              client_type == 'Persona fisica' &&
                              usoAbitativo == 1
                            "
                            value="0.04"
                          >
                            4%
                          </option>
                          <option value="0.22">22%</option>
                          <option
                            v-if="client_type == 'Partita IVA'"
                            value="0.00"
                          >
                            Reverse Charge
                          </option>
                        </select>
                      </div>

                      <div class="col-md-6 mb-3 center">
                        <h5 class="widthFull text-left black">
                          Beni significativi, quota eccedente accessori e
                          manodopera
                        </h5>
                      </div>
                      <div class="col-md-2 mb-3 center">
                        <select
                          class="form-control"
                          v-model="iva_age_extra"
                          id="iva_age_extra"
                          name="iva_age_extra"
                          data-vv-as="Beni significativi, quota eccedente accessori e manodopera"
                          v-validate="{ required: true }"
                          :class="{
                            'is-invalid': errors.has('form-2.iva_age_extra'),
                            valid: !!iva_age_extra,
                          }"
                        >
                          <option
                            v-if="
                              client_type != 'Partita IVA' && usoAbitativo == 1
                            "
                            value="0.10"
                          >
                            10%
                          </option>
                          <option
                            v-if="
                              client_type == 'Persona fisica' &&
                              usoAbitativo == 1
                            "
                            value="0.04"
                          >
                            4%
                          </option>
                          <option value="0.22">22%</option>
                          <option
                            v-if="client_type == 'Partita IVA'"
                            value="0.00"
                          >
                            Reverse Charge
                          </option>
                        </select>
                      </div>

                      <div class="col-md-6 mb-3 center">
                        <h5 class="widthFull text-left black">
                          Altri Beni / Accessori opzionali / Installazione e
                          Posa in Opera
                        </h5>
                      </div>
                      <div class="col-md-2 mb-3 center">
                        <select
                          class="form-control"
                          v-model="iva_accessori_lavoro"
                          id="iva_accessori_lavoro"
                          name="iva_accessori_lavoro"
                          data-vv-as="Altri Beni / Accessori opzionali / Installazione e Posa in Opera"
                          v-validate="{ required: true }"
                          :class="{
                            'is-invalid': errors.has(
                              'form-2.iva_accessori_lavoro'
                            ),
                            valid: !!iva_accessori_lavoro,
                          }"
                        >
                          <option
                            v-if="
                              client_type != 'Partita IVA' && usoAbitativo == 1
                            "
                            value="0.10"
                          >
                            10%
                          </option>
                          <option
                            v-if="
                              client_type == 'Persona fisica' &&
                              usoAbitativo == 1
                            "
                            value="0.04"
                          >
                            4%
                          </option>
                          <option value="0.22">22%</option>
                          <option
                            v-if="client_type == 'Partita IVA'"
                            value="0.00"
                          >
                            Reverse Charge
                          </option>
                        </select>
                      </div>

                      <div class="col-md-6 mb-3 center">
                        <h5 class="widthFull text-left black">
                          Altri oneri per il Committente
                        </h5>
                      </div>
                      <div class="col-md-2 mb-3 center">
                        <select
                          class="form-control"
                          v-model="iva_altri_oneri"
                          id="iva_altri_oneri"
                          name="iva_altri_oneri"
                          data-vv-as="Altri oneri per il Committente"
                          v-validate="{ required: true }"
                          :class="{
                            'is-invalid': errors.has('form-2.iva_altri_oneri'),
                            valid: !!iva_altri_oneri,
                          }"
                        >
                          <option
                            v-if="
                              client_type != 'Partita IVA' && usoAbitativo == 1
                            "
                            value="0.10"
                          >
                            10%
                          </option>
                          <option
                            v-if="
                              client_type == 'Persona fisica' &&
                              usoAbitativo == 1
                            "
                            value="0.04"
                          >
                            4%
                          </option>
                          <option value="0.22">22%</option>
                          <option
                            v-if="client_type == 'Partita IVA'"
                            value="0.00"
                          >
                            Reverse Charge
                          </option>
                        </select>
                      </div>

                      <div
                        v-if="
                          client_type == 'Persona fisica' &&
                          usoAbitativo == 1 &&
                          (iva_altri_oneri == '0.04' ||
                            iva_accessori_lavoro == '0.04' ||
                            iva_age_extra == '0.04' ||
                            iva_age_lavoro == '0.04')
                        "
                        class="col-md-8 mb-3 center text-left"
                      >
                        <h3 class="Bold center">Attenzione!</h3>
                        <b
                          >Non tutti gli acquisti e interventi, a prescindere,
                          possono essere considerati secondo l’aliquota
                          agevolata al 4% bensì esclusivamente quelli
                          prettamente collegati alla specifica disabilità del
                          cliente finale.
                        </b>
                        <br /><br /><b class="red"
                          >Occorre, pertanto, verificare la tipologia di
                          intervento da eseguire per verificare se il cliente
                          potrà o meno beneficiare dell’aliquota IVA al 4%.</b
                        >
                        <br />
                        <p class="mt-2 center">
                          Consulta la
                          <a
                            class="Bold underline black"
                            href="https://storage.googleapis.com/chebonus/Guida_alle_agevolazioni_fiscali_per_le_persone_con_disabilita.pdf"
                            target="_blank"
                            >guida</a
                          >
                          relativa alle agevolazioni fiscali per le persone con
                          disabilità.
                        </p>
                      </div>
                    </div>

                    <!-- END IVA CHOICE -->

                    <div class="row justify-content-center divider"></div>

                    <div class="row pt-2">
                      <div
                        v-if="requiredOperations"
                        class="col-md-12 mb-3 requiredCont"
                      >
                        <h5 class="green">
                          Requisiti tecnici richiesti per aderire al bonus:
                        </h5>
                        <h5 class="black" v-html="requiredOperations"></h5>
                      </div>
                    </div>

                    <div class="row justify-content-center divider"></div>

                    <!-- ENEA INPUT -->
                    <div class="row"></div>
                  </div>

                  <div class="row justify-content-center divider"></div>
                </div>
              </form>
            </tab-content>
            <!--   END STEP 3 PRODUCTS DATA   ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

            <!-- STEP 4 ANTERPRIMA *********************************************************************************************** -->
            <tab-content
              title="Anteprima"
              subtitle="Tutti i campi sono obbligatori"
              icon=""
              :before-change="validateThirdTab"
            >
              <form
                v-if="calcFinish"
                data-vv-scope="form-3"
                class="widthFull orio pt-3 pr-md-3"
                autocomplete="qwerqrt3"
              >
                <div class="widthFull" ref="invoiceData">
                  <div
                    class="row justify-content-center divider fordelete"
                  ></div>

                  <!-- DATA TABLE -->
                  <table class="table table-bordered mb-0 mt-4">
                    <tbody>

                      
                      <tr>
                        <td scope="row">
                           <b>Cessionario/prestatore (fornitore)</b>

                          <br />Identificativo fiscale ai fini IVA:
                          <b>IT03402390409</b>
                          <br />Denominazione: <b>EMICON A.C. S.p.A.</b>
                          <br />Indirizzo:
                          <b
                            >Via A. Volta, 49</b
                          >
                          <br />Comune:
                          <b
                            >Meldola (FC) Italy</b
                          >
                          <br />Cap: <b>47014</b>
                          <br />
                          <br />Email: <b>{{ getProfile.email }}</b>
                          <br />Cellulare: <b>{{ getProfile.cellulare }}</b>

                          <br />IBAN: <b>{{ getProfile.iban }}</b>
                        </td>

                        <td style="vertical-align: top; text-align: center">
                          <img
                            v-if="getProfile.logo"
                            class="img-fluid"
                            :src="getProfile.logo"
                            style="width: 50% !important; max-width: 150px"
                          />
                        </td>

                        <td style="vertical-align: top">
                          <b>Benificiario/committente (cliente)</b>
                          <br />Denominazione:
                          <b>{{ clientName }} {{ clientLastname }}</b>
                          <br />Indirizzo: <b>{{ adress }} {{ civic }}</b>
                          <br />Comune: <b>{{ city.city }} ({{ province }})</b>
                          <br />Cap: <b>{{ zip }}</b>
                          <br />
                          <br />Email: <b>{{ client_email }}</b> <br /><span
                            v-if="client_phone"
                            >Telefono: <b>{{ client_phone }}</b></span
                          >
                          <br /><span v-if="client_mobile"
                            >Cellulare: <b>{{ client_mobile }}</b></span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <h4 class="Regular widthFull text-left pt-4 h0 black">
                    <b>La tua offerta:</b>
                  </h4>

                  <h5
                    v-if="getProfile.reg_forfettario == 'si'"
                    class="Regular widthFull text-left h0 black"
                  >
                    Operazione effettuata ai sensi dell'art. 1, commi da 54 a 89
                    della Legge n. 190/2014, così come modificato dalla Legge
                    numero 208/2015 e dalla Legge 145/2018 art. 1 Commi 9-11.
                  </h5>

                  <h5
                    v-else-if="
                      client_type == 'Partita IVA' &&
                      iva_age_lavoro == '0.00' &&
                      iva_age_extra == '0.00'
                    "
                    class="Regular widthFull text-left h0 black"
                  >
                    Operazione soggetta al reverse charge art. 17, comma 6,
                    lett. a-ter DPR 633/1972.
                  </h5>

                  <table class="table table-bordered mb-0">
                    <thead></thead>
                    <tbody>
                      <tr class="greenBg">
                        <td colspan="4">
                          <b class="uppercase">Beni significativi</b>
                        </td>
                      </tr>
                      <tr>
                        <th scope="col">Codice prodotto</th>
                        <th scope="col">Prodotto/servizio</th>
                        <th scope="col">Quantita</th>
                        <th scope="col">Prezzo unitario</th>
                      </tr>
                      <tr v-for="(item, ind) in products">
                        <td scope="row">{{ item.product.serial }}</td>
                        <td>
                          <b>{{ item.product.name }}</b>
                        </td>
                        <td>
                          <b>{{ item.quantity }}</b>
                        </td>
                        <td class="text-right">
                          <b>{{ item.price }} €</b>
                        </td>
                      </tr>

                      <tr>
                        <td align="right">
                          <b class="uppercase text-right widthFull"
                            >Totale Beni Significativi</b
                          >
                        </td>
                        <td align="right">
                          <b>{{ totalProducts }} €</b>
                        </td>

                        <td align="right">
                          <b class="uppercase text-right widthFull"
                            >Totale Agevolabile Beni Significativi</b
                          >
                        </td>
                        <td align="right">
                          <b
                            >{{
                              (
                                parseFloat(
                                  totalProducts
                                    .replace(".", "")
                                    .replace(",", ".")
                                ) - parseFloat(totalExtraMise)
                              ).toFixed(2) | formatNumber
                            }}
                            €</b
                          >
                        </td>
                      </tr>
                      <tr class="greenBg">
                        <td colspan="4">
                          <b class="uppercase"> Altri beni ed accessori</b>
                        </td>
                      </tr>
                      <tr>
                        <th scope="col">Codice prodotto</th>
                        <th scope="col">Prodotto/servizio</th>
                        <th scope="col">Quantita</th>
                        <th scope="col">Prezzo unitario</th>
                      </tr>

                      <tr v-for="(item, ind) in accessories">
                        <td scope="row">{{ item.product.serial }}</td>
                        <td>
                          <b>{{ item.product.name }}</b>
                        </td>
                        <td>
                          <b>{{ item.quantity }}</b>
                        </td>
                        <td class="text-right">
                          <b>{{ item.price }} € </b>
                        </td>
                      </tr>

                      <tr>
                        <th scope="row"></th>
                        <td colspan="2">Importo installazione/posa in opera</td>
                        <td class="text-right">
                          <b> {{ priceWork }} € </b>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="3" align="right">
                          <b class="uppercase"
                            >Totale altri beni ed accessori
                            <template v-if="getProfile.reg_forfettario != 'si'"
                              >imponibile</template
                            ></b
                          >
                        </td>
                        <td align="right">
                          <b
                            >{{
                              (parseFloat(
                                totalAccessories
                                  .replace(".", "")
                                  .replace(",", ".")
                              ) +
                                parseFloat(
                                  priceWork.replace(".", "").replace(",", ".")
                                ))
                                | formatNumber
                            }}
                            €</b
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div class="row ml-0 mr-0 greyBg pt-2">
                    <table class="table table-bordered mb-0">
                      <tbody>
                        <tr class="greyBg">
                          <td colspan="3" align="right">
                            <b class="uppercase" align="right"
                              >Totale intervento
                              <template
                                v-if="getProfile.reg_forfettario != 'si'"
                                >imponibile</template
                              ></b
                            >
                          </td>
                          <td width="220" align="right">
                            <b>{{ calcInfo.totalBase | formatNumber }} €</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <table
                    v-if="getProfile.reg_forfettario != 'si'"
                    class="table table-bordered mb-0"
                  >
                    <thead>
                      <tr class="greenBg">
                        <td colspan="4"><b class="uppercase">Riepilogo</b></td>
                      </tr>
                      <tr>
                        <td align="left" scope="row"></td>
                        <td class="text-right">
                          <b
                            >Importo
                            <template v-if="getProfile.reg_forfettario != 'si'"
                              >imponibile</template
                            ></b
                          >
                        </td>
                        <td class="text-right"><b>Aliquota IVA</b></td>
                        <td class="text-right"><b>Totale (IVA Inclusa)</b></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td align="left" scope="row">
                          Beni significativi, quota concorrente accessori e
                          manodopera
                        </td>
                        <td class="text-right">
                          <b>{{ age_lavoro | formatNumber }} €</b>
                        </td>
                        <td class="text-right">
                          <b>{{ iva_age_lavoro * 100 }} %</b>
                        </td>
                        <td class="text-right">
                          <b
                            >{{
                              (
                                parseFloat(age_lavoro) *
                                (1 + parseFloat(iva_age_lavoro))
                              ).toFixed(2) | formatNumber
                            }}
                            €</b
                          >
                        </td>
                      </tr>

                      <tr>
                        <td align="left" scope="row">
                          Beni significativi, quota eccedente accessori e
                          manodopera
                        </td>
                        <td class="text-right">
                          <b>{{ age_extra | formatNumber }} €</b>
                        </td>
                        <td class="text-right">
                          <b>{{ iva_age_extra * 100 }} %</b>
                        </td>
                        <td class="text-right">
                          <b
                            >{{
                              (
                                parseFloat(age_extra) *
                                (1 + parseFloat(iva_age_extra))
                              ).toFixed(2) | formatNumber
                            }}
                            €</b
                          >
                        </td>
                      </tr>

                      <tr>
                        <td align="left" scope="row">
                          Altri Beni / Accessori opzionali / Installazione e
                          Posa in Opera
                        </td>
                        <td class="text-right">
                          <b
                            >{{
                              (parseFloat(
                                totalAccessories
                                  .replace(".", "")
                                  .replace(",", ".")
                              ) +
                                parseFloat(
                                  priceWork.replace(".", "").replace(",", ".")
                                ))
                                | formatNumber
                            }}
                            €</b
                          >
                        </td>
                        <td class="text-right">
                          <b>{{ iva_accessori_lavoro * 100 }} %</b>
                        </td>
                        <td class="text-right">
                          <b
                            >{{
                              (
                                (parseFloat(
                                  totalAccessories
                                    .replace(".", "")
                                    .replace(",", ".")
                                ) +
                                  parseFloat(
                                    priceWork.replace(".", "").replace(",", ".")
                                  )) *
                                (1 + parseFloat(iva_accessori_lavoro))
                              ).toFixed(2) | formatNumber
                            }}
                            €</b
                          >
                        </td>
                      </tr>

                      <!-- this.age_extra = x22 -->
                    </tbody>
                  </table>

                  <div class="row ml-0 mr-0 greyBg pt-2">
                    <table class="table table-bordered mb-0">
                      <tbody>
                        <tr class="greyBg">
                          <td colspan="3" align="right">
                            <b class="uppercase" align="right"
                              >Totale fattura Spesa agevolabile
                              <template
                                v-if="getProfile.reg_forfettario != 'si'"
                                >(IVA INCLUSA)</template
                              >
                            </b>
                          </td>
                          <td align="right" width="220">
                            <b
                              >{{
                                calcInfo.totalBaseAndIva | formatNumber
                              }}
                              €</b
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <td colspan="2" scope="row" class="uppercase">
                          Sconto in fattura {{ this.ecoBonus }}
                          <template v-if="getProfile.reg_forfettario != 'si'">
                            <template
                              v-if="
                                ecoBonus != 'Bonus Casa 50%' &&
                                this.client_type == 'Partita IVA' &&
                                this.usoAbitativo == 0 &&
                                this.iva_age_lavoro == '0.22' &&
                                this.iva_age_extra == '0.22' &&
                                this.iva_accessori_lavoro == '0.22'
                              "
                            >
                            </template
                            ><template v-else> (IVA INCLUSA)</template>
                          </template>
                          <span
                            v-if="ecoBonus != 'Bonus Casa 50%'"
                            class="small"
                          >
                            (Art. 121, D.L. 34/20 convertito con Legge 17 luglio
                            2020)
                          </span>
                        </td>

                        <td class="text-right">
                          <b>{{ calcInfo.totalWithBonus | formatNumber }} €</b>
                        </td>
                      </tr>

                      <tr class="greyBg">
                        <td
                          colspan="2"
                          align="right"
                          class="text-right uppercase"
                          scope="row"
                        >
                          <b
                            >Totale fattura al committente per bonifico parlante
                            <template v-if="getProfile.reg_forfettario != 'si'"
                              >(IVA INCLUSA)</template
                            >
                            <span
                              class="small"
                              v-if="ecoBonus == 'Bonus Casa 50%'"
                            >
                              (Art. 16 bis, D.P.R. 917/86)</span
                            >
                            <span
                              class="small"
                              v-if="ecoBonus != 'Bonus Casa 50%'"
                            >
                              (Art. 1, Legge 296/2006 e art. 14 D.L.
                              63/2013)</span
                            >
                          </b>
                        </td>

                        <td class="text-right">
                          <b
                            >{{
                              (parseFloat(calcInfo.totalBaseAndIva) -
                                parseFloat(calcInfo.totalWithBonus))
                                | formatNumber
                            }}
                            €</b
                          >
                        </td>
                      </tr>
                      <tr class="greenBg">
                        <td colspan="4">
                          <b class="uppercase"
                            >Altri oneri per il committente</b
                          >
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" align="left" scope="row">
                          Quota spesa non agevolata
                          <template v-if="getProfile.reg_forfettario != 'si'"
                            >(IVA {{ iva_altri_oneri * 100 }} %
                            INCLUSA)</template
                          >
                        </td>

                        <td class="text-right">
                          <b
                            >{{
                              (
                                parseFloat(totalExtraMise) +
                                parseFloat(calcInfo.iva22NonAge) +
                                parseFloat(calcInfo.iva10NonAge)
                              ).toFixed(2) | formatNumber
                            }}
                            €</b
                          >
                        </td>
                      </tr>

                      <tr>
                        <td align="left">
                          Gestione Pratica ENEA
                          <template v-if="getProfile.reg_forfettario != 'si'"
                            >(IVA {{ iva_altri_oneri * 100 }} %
                            INCLUSA)</template
                          >
                        </td>

                        <td align="left">
                          <div class="form-check hideOnPdf">
                            <input
                              type="checkbox"
                              v-model="zeroEnea"
                              class="form-check-input"
                              id="zeroEnea"
                              key="1111"
                            />
                            <label class="form-check-label" for="zeroEnea">
                              <b>Escludi questa voce dal preventivo</b>
                            </label>
                          </div>
                        </td>

                        <td
                          v-if="getProfile.reg_forfettario != 'si'"
                          class="text-right"
                        >
                          <b
                            >{{
                              (
                                parseFloat(
                                  priceEnea.replace(".", "").replace(",", ".")
                                ) *
                                (1 + parseFloat(iva_altri_oneri))
                              ).toFixed(2)
                            }}
                            €</b
                          >
                        </td>
                        <td v-else class="text-right">
                          <b
                            >{{
                              parseFloat(
                                priceEnea.replace(".", "").replace(",", ".")
                              ).toFixed(2)
                            }}
                            €</b
                          >
                        </td>
                      </tr>

                      <!--<tr>
                      <td align="left" scope="row">Recupero Dati Catastali <template v-if="getProfile.reg_forfettario != 'si'">(IVA {{ iva_altri_oneri * 100 }} % INCLUSA)</template></td>

                      <td align="left">
                        <div class="form-check hideOnPdf">
                          <input type="checkbox" v-model="zeroDcast" class="form-check-input" id="zeroDcast" key="2311">
                          <label class="form-check-label" for="zeroDcast"> <b>Escludi questa voce dal preventivo</b> </label>
                        </div>
                      </td>

                    
                      <td v-if="getProfile.reg_forfettario != 'si'" class="text-right"><b>{{ ( parseFloat(priceDcast) * ( 1 +  parseFloat(iva_altri_oneri))  ).toFixed(2) }} €</b></td>
                      <td v-else class="text-right"><b>{{ ( parseFloat(priceDcast) ).toFixed(2) }} €</b></td>
                    

                    </tr>-->

                      <tr>
                        <td align="left" scope="row">
                          Oneri Finanziari
                          <template v-if="getProfile.reg_forfettario != 'si'"
                            >(IVA ESENTE)</template
                          >
                        </td>
                        <td align="left">
                          <div class="form-check hideOnPdf">
                            <!--<input
                              type="checkbox"
                              v-model="zeroOneri"
                              class="form-check-input"
                              id="zeroOneri"
                              key="2222"
                            />
                            <label class="form-check-label" for="zeroOneri">
                              <b>Escludi questa voce dal preventivo</b>
                            </label>-->
                            <label
                              class="form-check-label btn btn-sm btn-primary"
                              for="zeroOneri"
                              v-on:click="modPrice('oneri')"
                            >
                              <b>Modifica</b>
                            </label>
                          </div>
                        </td>
                        <td class="text-right" v-if="!pricenewFlag">
                          <b
                            >{{
                              (parseFloat(calcInfo.allOneri) -
                                parseFloat(calcInfo.serviceCost) *
                                  (1 + parseFloat(iva_altri_oneri)))
                                | formatNumber
                            }}
                            €</b
                          >
                        </td>
                        <td class="text-right" v-else>
                          <b
                            >{{
                              (parseFloat(calcInfo.allOneri) -
                                parseFloat(calcInfo.serviceCost) *
                                  (1 + parseFloat(iva_altri_oneri)))
                                | formatNumber
                            }}
                            €</b
                          >
                        </td>
                      </tr>

                      <tr>
                        <td align="left" scope="row">
                          Costi di gestione pratica
                          <template v-if="getProfile.reg_forfettario != 'si'"
                            >(IVA {{ iva_altri_oneri * 100 }} %
                            INCLUSA)</template
                          >
                        </td>
                        <td align="left">
                          <div class="form-check hideOnPdf">
                            <!--<input
                              type="checkbox"
                              v-model="zeroPratica"
                              class="form-check-input"
                              id="zeroPratica"
                              key="3333"
                            />
                            <label class="form-check-label" for="zeroPratica">
                              <b>Escludi questa voce dal preventivo</b>
                            </label>-->
                            <label
                              class="form-check-label btn btn-sm btn-primary"
                              for="zeroPratica"
                              v-on:click="modPrice('pratica')"
                            >
                              <b>Modifica</b>
                            </label>
                          </div>
                        </td>
                        <td class="text-right" v-if="!pricenewFlag">
                          <b
                            >{{
                              (parseFloat(calcInfo.serviceCost) *
                                (1 + parseFloat(iva_altri_oneri)))
                                | formatNumber
                            }}
                            €</b
                          >
                        </td>
                        <td class="text-right" v-else>
                          <b
                            >{{
                              (parseFloat(calcInfo.serviceCost) *
                                (1 + parseFloat(iva_altri_oneri)))
                                | formatNumber
                            }}
                            €</b
                          >
                        </td>
                      </tr>

                      <tr class="greyBg">
                        <td
                          colspan="2"
                          align="right"
                          class="text-right uppercase"
                          scope="row"
                        >
                          <b
                            >Totale altri oneri per il committente
                            <template v-if="getProfile.reg_forfettario != 'si'"
                              >(IVA {{ iva_altri_oneri * 100 }} %
                              INCLUSA)</template
                            ></b
                          >
                        </td>

                        <td class="text-right">
                          <b v-if="getProfile.reg_forfettario != 'si'">
                            {{
                              (
                                parseFloat(totalExtraMise) +
                                parseFloat(calcInfo.iva22NonAge) +
                                parseFloat(calcInfo.iva10NonAge) +
                                parseFloat(priceDcast) *
                                  (1 + parseFloat(iva_altri_oneri)) +
                                parseFloat(
                                  priceEnea.replace(".", "").replace(",", ".")
                                ) *
                                  (1 + parseFloat(iva_altri_oneri)) +
                                parseFloat(calcInfo.allOneri)
                              ).toFixed(2) | formatNumber
                            }}
                            €</b
                          >
                          <b v-else>
                            {{
                              (
                                parseFloat(totalExtraMise) +
                                parseFloat(calcInfo.iva22NonAge) +
                                parseFloat(calcInfo.iva10NonAge) +
                                parseFloat(priceDcast) +
                                parseFloat(
                                  priceEnea.replace(".", "").replace(",", ".")
                                ) +
                                parseFloat(calcInfo.allOneri)
                              ).toFixed(2) | formatNumber
                            }}
                            €</b
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div class="row ml-0 mr-0 pt-2">
                    <table class="table table-bordered mb-0 greyBg">
                      <tbody>
                        <tr class="greyBg">
                          <th colspan="3" class="text-right" align="right">
                            <b class="uppercase" align="right"
                              >Totale da pagare <br />
                              ( a carico dell’utente finale
                              <template
                                v-if="getProfile.reg_forfettario != 'si'"
                                >, IVA inclusa</template
                              >
                              )</b
                            >
                          </th>
                          <td align="right" width="220">
                            <b>{{ calcInfo.finalPrice | formatNumber }} €</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table class="table mb-0 mt-3 greyBg">
                      <tbody>
                        <tr class="greyBg">
                          <td colspan="3" align="left">
                            <template v-if="getProfile.reg_forfettario == 'si'">
                              Operazione in franchigia da Iva ex art. 1 cc.
                              54-89 L. 190/2014
                            </template>

                            <br /><br />

                            L’utilizzo dei servizi descritti sul Sito comporta
                            l’integrale accettazione dei
                            <a
                              :href="utilizzoPolicy"
                              target="_blank"
                              class="green"
                            >
                              Termini e delle condizioni di riferimento
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="widthFull mt-5">
                  <div class="row justify-content-center">
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th scope="row">
                            IMPORTO TOTALE DEL CREDITO CEDUTO
                            <!-- INCASSO
                          <template v-if="getProfile.reg_role == 'General Contractor'"> DEL GENERAL CONTRACTOR </template>
                          <template v-if="getProfile.reg_role != 'General Contractor'"> DELL’INSTALLATORE </template>
                          DA CESSIONE DEL CREDITO
                          --></th>

                          <td class="text-right">
                            <b
                              >{{ calcInfo.totalWithBonus | formatNumber }} €</b
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </form>
            </tab-content>
            <!-- END STEP 4 ANTERPRIMA *********************************************************************************************** -->
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AUTH_REQUEST, AUTH_SOCIAL } from "actions/auth";
import { USER_REQUEST } from "actions/user";
import { ADD_NOTIFICATIONS, GET_NOTIFICATIONS } from "actions/notifications";

import { mapGetters, mapState } from "vuex";
import axios from "axios";
const moment = require("moment");

const numeral = require("numeral");
//import numFormat from 'vue-filter-number-format';

import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import Datepicker from "vuejs-datepicker";
import { it } from "vuejs-datepicker/dist/locale";

// GET DOC LIST
import documents from "../documents/documents.js";

export default {
  name: "emicon",
  data() {
    return {
      username: "",
      documents: documents,
      password: "",
      token: "",
      numeral: require("numeral"),
      proccess: "START",
      loading: false,
      priceAcc: "",

      // NEWWWWWW
      zeroEnea: false,
      zeroDcast: false,
      zeroOneri: false,
      zeroPratica: false,
      zeroEneaOld: "",
      zeroDcastOld: "",
      zeroOneriOld: "",
      zeroPraticaOld: "",

      priceWork: "",
      tempMail: "",
      socialEmail: false,
      social: "",
      items: {},
      ecoBonus: "",
      itemsAccessories: {},
      calcFinish: false,
      groups: {
        
        /*0: {
          name: "Caldaia a condensazione",
          value: "condensazione",
        },
        1: {
          name: "Caldaia tradizionale",
          value: "tradizionale",
        },*/
        0: {
          name: "Pompa di calore",
          value: "pompadicalore",
        },
        /*3: {
          name: "Sistemi Ibridi kit completo",
          value: "ibridi",
        },
        4: {
          name: "Scaldacqua PDC",
          value: "scaldacqua",
        },
        5: {
          name: "Climatizzatore",
          value: "climatizzatore",
        },
        5: {
          name: "Collettore solare termico",
          value: "solare",
        },*/
        1: {
          name: "Altro Prodotto",
          value: "altroVaillant",
        },
      },
      groupsAccessori: {
        /*0: {
          name: "Termoregolazione evoluta",
          value: "termoregolazione",
        },
        1: {
          name: "Altro Accessorio",
          value: "altroV",
        },
        2: {
          name: "Valvole termostatiche",
          value: "valvole_termostatiche",
        },*/
        0: {
          name: "Altro materiale/valvolame",
          value: "altro",
        },
      },
      confirmed: true,
      usoAbitativo: 1,
      resend_success: false,
      loadingState2: false,
      loadingState: false,
      privacyPolicy: process.env.PRIVACY,
      cookiePolicy: process.env.COOKIE,
      utilizzoPolicy: process.env.UTILIZZO,
      passwordFieldType: "password",
      moment: moment,
      productIndex: 0,
      accessoriesIndex: 0,
      calcInfo: {},
      products: [
        {
          index: "product" + 0,
          indexCount: "quantity" + 0,
          group: "",
          product: "",
          price: "",
          quantity: "",
          kw: "",
          error: false,
        },
      ],

      accessories: [
        {
          index: "product" + 0,
          indexCount: "quantity" + 0,
          group: "",
          product: "",
          price: "",
          quantity: "",
          kw: "",
          error: false,
        },
      ],

      quantity: "",
      finish: process.env.FINISH,
      vw: window.innerWidth,
      stepSize: "md",

      // TAB 1 CLIENT
      clientLastname: "",
      clientName: "",
      adress: "",
      civic: "",
      email: "",
      phone: "",
      mobile: "",
      provincies: [],
      province: "",
      provinciesState: true,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      city: "",
      zip: "",
      datiCatastali: "0",

      client_mobile: "",
      client_phone: "",
      client_email: "",
      //TAB2 INTERVENTO
      eventType: "",
      eventStartdate: "",
      it: it,
      eventStartdate: "",
      disabledDatesStart: {
        to: "",
        from: "",
      },
      allProducts: {},
      totalAccessories: "0,00",
      totalProducts: "0,00",
      enea: "0",
      requiredOperations: "",
      client_type: "",
      priceEnea: "0",
      client_ownership: "Proprietario",
      totalExtraMise: 0,
      clearExtraMise: false,
      NoEnea: true,
      priceDcast: "0",

      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,
      priceNew: 0,
      pricenewFlag: false,
      costoAttualizazioneChange: false,
      serviceCostChange: false,
      age_lavoro: 0,
      age_extra: 0,
      corporateClient:''
    };
  },
  components: {
    FormWizard,
    TabContent,
    Datepicker,
  },
  methods: {
    keymonitor(event, index, type) {
      this.$log(event);
      if (event.key == ".") {
        if (type == "prod") {
          var i = index.slice(7, index.length);
          this.products[i].price = this.products[i].price.replace(".", ",");
        } else {
          this.$log(event.key);
          var i = index.slice(7, index.length);
          this.accessories[i].price = this.accessories[i].price.replace(
            ".",
            ","
          );
        }
      }
    },
    setBonus(value) {
      this.ecoBonus = value;
      var note = {};
      note.text =
        "Perfetto hai scelto " +
        value +
        ' adesso clicca sul pulsante "avanti" e prosegui con il prossimo step.';
      note.type = "NOTIFICATION";
      this.$store.dispatch(ADD_NOTIFICATIONS, note);

      var _vue = this;
      setTimeout(function () {
        // NEWWWWWWWW
        if (_vue.ecoBonus == "Bonus Casa 50%") {
          _vue.clearExtraMise = true;
        } else {
          _vue.clearExtraMise = false;
        }
        _vue.calcTotalPriceProducts();
      }, 3000);
    },
    stepIndex(from, to) {
      if (to == 2) {
        this.$log("CHECK ALL PRODUCTS WITH EXIST RULES");
        // CHECK ALL PRODUCTS WITH EXIST RULES
        var prod = this.products;
        for (var x in prod) {
          this.$log(prod[x]);
          this.checkProductWithBonusRules(prod[x].index);
        }

        var acc = this.accessories;
        for (var y in acc) {
          this.checkAccessoriesWithBonusRules(acc[y].index);
        }
      }

      if (from == 0 && to == 1 && this.ecoBonus == "Superbonus 110%") {
        this.$router.push("/superbonus");
      }

      this.$log(from + " => " + to);
    },
    checkIfEmpty(element) {
      this.$log(element.target.id);
      var id = element.target.id;
      var index = id.slice(8, id.length);
      if (id.includes("pproduct") && this.products[index].group == "") {
        this.products[index].error = true;
      } else {
        this.products[index].error = false;
      }
    },
    // WIZARD STEPS VALIDATES ***************************************************************
    validateZeroTab() {
      var _vue = this;
      this.$validator.validateAll("form-0").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170,
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170,
          });
        }
      });
      return this.$validator.validateAll("form-0");
    },
    validateFirstTab() {
      var _vue = this;
      this.$validator.validateAll("form-1").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170,
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170,
          });
        }
      });
      return this.$validator.validateAll("form-1");
      return true;
    },
    validateSecondTab: function () {
      var _vue = this;
      this.$validator.validateAll("form-2").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170,
          });
        } else {
          _vue.beginCalc("si");
          _vue.$scrollTo("#app", 700, {
            offset: -170,
          });
        }
      });
      this.$store.dispatch(USER_REQUEST);
      return this.$validator.validateAll("form-2");
    },
    validateThirdTab: function () {
      var _vue = this;
      this.$validator.validateAll("form-3").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170,
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170,
          });
        }
      });
      return this.$validator.validateAll("form-3");
    },
    modPrice: function (selectorModPrice) {
      var txt = "";
      if (selectorModPrice == "oneri") {
        txt +=
          parseFloat(this.calcInfo.allOneri) -
          parseFloat(this.calcInfo.serviceCost) *
            (1 + parseFloat(this.iva_altri_oneri));
      }
      if (selectorModPrice == "pratica") {
        txt +=
          parseFloat(this.calcInfo.serviceCost) *
          (1 + parseFloat(this.iva_altri_oneri));
      }
      var _vue = this;
      _vue.pricenewFlag = false;

      this.$swal({
        title: "MODIFICA PREZZO",
        html:
          txt +
          '<br /><br />Prezzo aggiornato:<input type="number" step="0.01" id="swal-input1" placeholder = "Prezzo.." class="swal2-input">',
        placeholder: "Inserisci il prezzo",
        inputAttributes: {
          autocapitalize: "off",
        },
        reverseButtons: true,
        confirmButtonText: "CONTINUA",
        showCancelButton: true,
        cancelButtonText: "ANNULLA",
        cancelButtonColor: "red",
        //confirmButton: 'closeProductsModal',
        confirmButtonColor: "#b61617",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          _vue.priceNew = document.getElementById("swal-input1").value;
          _vue.priceNew = _vue.priceNew.replace(/,/g, ".");
          _vue.priceNew = _vue.priceNew.replace("€", "");
          _vue.priceNew = _vue.priceNew.replace(/\s/g, "");
          if (selectorModPrice == "pratica") {
            _vue.calcInfo.serviceCost =
              parseFloat(_vue.priceNew) /
              (1 + parseFloat(_vue.iva_altri_oneri));
            this.serviceCostChange = true;
          }

          if (selectorModPrice == "oneri") {
            _vue.calcInfo.costoAttualizazione = parseFloat(_vue.priceNew);
            this.costoAttualizazioneChange = true;
          }

          _vue.beginCalc("nopopup");
          _vue.pricenewFlag = true;
        },
      }).then((result) => {});
    },
    async prepareDocumentList() {
      // DOC LIST PARSER TO SEND IN BACKEND AND INSERT IN PREVENTIVO
      var docTemp = this.documents[this.client_type];
      this.documents[this.client_type] = {};

      var selettore_titoloPossesso = this.client_ownership;
      var selettore_enea = this.enea;

      if (selettore_enea == "0") {
        selettore_enea = "no";
      } else {
        selettore_enea = "yes";
      }

      for (var ele in docTemp) {
        if (docTemp[ele].hasOwnProperty("codice")) {
          this.documents[this.client_type][ele] = docTemp[ele];
        } else if (docTemp[ele].hasOwnProperty("selector")) {
          if (
            docTemp[ele]["selector"].hasOwnProperty(
              selettore_titoloPossesso.toLowerCase()
            )
          ) {
            var tmpList =
              docTemp[ele]["selector"][selettore_titoloPossesso.toLowerCase()];
          } else if (docTemp[ele]["selector"].hasOwnProperty(selettore_enea)) {
            var tmpList =
              docTemp[ele]["selector"][selettore_enea.toLowerCase()];
          }
          for (var eleS in tmpList) {
            this.documents[this.client_type][eleS] = tmpList[eleS];
          }
        }
      }

      var docsFinal = this.documents[this.client_type];
      var docHtml =
        '<br/><br/><br/><h5>Documenti da preparare ( dopo conferma preventivo )</h5><table class="table table-bordered mb-0"><thead></thead><tbody> <tr> <th>N.</th> <th>Nome Documento</th> <th>Obbligatorio</th> </tr>';
      var i = 1;
      for (var x in docsFinal) {
        var obl = docsFinal[x].mandatory == "yes" ? "SI" : "NO";
        docHtml =
          docHtml +
          "<tr> <th>" +
          i +
          '</th><th align="left"> ' +
          docsFinal[x].name +
          "</th><th> " +
          obl +
          "</th></tr>";
        i = i + 1;
      }
      docHtml = docHtml + "</tbody></table>";
      return docHtml;

      //****************************************************************************************************
    },
    async onComplate() {
      this.loadingState = true;

      //var docsFinal = await this.prepareDocumentList()
      var docsFinal = "";
      // PREPARE DATA TO POST
      var data = {};
      // PASS DOC LIST
      data.docs = docsFinal;
      data.serviceCost = this.serviceCostChange
        ? this.calcInfo.serviceCost
        : "no";
      data.costoAttualizazione = this.costoAttualizazioneChange
        ? this.calcInfo.costoAttualizazione
        : "no";
      // ALL USER DATA
      data.user = this.getProfile;
      // BONUS SELECTED
      data.bonus = this.ecoBonus;
      // CLIENT DATA
      data.client_name = this.clientName;
      data.client_lastname = this.clientLastname;
      data.client_type = this.client_type;

      data.client_mobile = this.client_mobile;
      data.client_phone = this.client_phone;
      data.client_email = this.client_email;

      // NEWWWWWWWWW
      if (this.zeroEnea) {
        data.client_price_enea = this.zeroEneaOld;
      } else {
        data.client_price_enea = this.priceEnea;
      }

      // NEWWWWWWWWW 2
      if (this.zeroDcast) {
        data.client_price_dcast = this.zeroDcastOld;
      } else {
        data.client_price_dcast = this.priceDcast;
      }

      data.client_ownership = this.client_ownership;
      data.corporateClient = this.getProfile.corporateClient
        ? this.getProfile.corporateClient
        : "";
      // CLIENT HOUSE DATA
      data.building_province = this.province;
      data.building_city = this.city.city;
      data.building_zip = this.zip;
      data.building_address = this.adress;
      data.building_civic = this.civic;
      // TO GET CADASTRAL DATA ?
      data.to_get_cadastral_data = this.datiCatastali;
      // INTERVENTION DATA
      data.intervention_type = this.eventType;
      data.intervention_date = moment(this.eventStartdate).format("YYYY-MM-DD");
      // PRODUCTS & ACCESSORIES
      data.products = this.products;
      data.accessories = this.accessories;
      data.enea_request = this.enea;
      data.created_at = moment().format("YYYY-MM-DD HH:mm:00");
      data.created_date = moment().format("DD-MM-YYYY HH:mm");

      // CASH VALUES
      data.total_product_price = this.totalProducts;
      data.total_accessories_price = this.totalAccessories;
      data.price_work = this.priceWork;

      data.total_transfer_for_user = this.calcInfo.aInstallatore;
      data.total_transfer_for_client = this.calcInfo.finalPrice;
      data.total_bonus_savings = this.calcInfo.totalWithBonus;
      data.total_work_and_iva = this.calcInfo.totalBaseAndIva;

      data.iva_altri_oneri = this.iva_altri_oneri;
      data.iva_accessori_lavoro = this.iva_accessori_lavoro;
      data.iva_age_extra = this.iva_age_extra;
      data.iva_age_lavoro = this.iva_age_lavoro;
      data.iva_age_accessori = this.iva_age_accessori;

      // HTML FOR PDF
      data.htmlInvoice = this.$refs.invoiceData.innerHTML;
      //requiredOperations: '',

      data.building_uso_abitativo = this.usoAbitativo;
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      axios({
        url: process.env.ROOT_API + "api/savePriceQuotation",
        method: "POST",
        data: { data },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          var alert = {};
          alert.text = "Il tuo preventivo è stato salvato correttamento";
          alert.type = "SUCCESS";
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "success",
            title: "Preventivo salvato",
            html: alert.text,
          });
          this.loadingState = false;

          this.$router.push("/offerte");
        })
        .catch((resp) => {
          this.$swal({
            type: "error",
            title: "Ops....",
            html: "Riprova più tardi",
          });
          this.loadingState = false;
        });
    },

    // MAIN CALC ***************************************************************
    beginCalc(display) {
      //this.proccess = 'CALC'
      var percentbonusDetr;
      var percentToPay;
      if (this.ecoBonus == "Bonus Casa 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 65%") {
        percentbonusDetr = 65;
        percentToPay = 35;
      }
      if (this.ecoBonus == "Superbonus 110%") {
        percentbonusDetr = 110;
        percentToPay = 0;
      }

      if (display != "nopopup") {
        this.calcInfo = {};
      }

      // COSTO SERVIZI
      // COSTO SERVIZI
      if (display != "nopopup") {
        //this.calcInfo.serviceCost = 160
        this.calcInfo.serviceCost = process.env.PRACTIC_PRICE;
      }
      //var AttPercent = 10.58
      var AttPercent = process.env.FINANCE_COST;

      var totProducts = parseFloat(
        this.totalProducts.replace(".", "").replace(",", ".")
      ).toFixed(2); // TOTALE PRODOTTI
      var totalExtraMise = this.totalExtraMise; // TOTALE NON AGEVOLATO
      var totAge = (
        parseFloat(totProducts.replace(",", ".")) -
        parseFloat(totalExtraMise.replace(",", "."))
      ).toFixed(2); // TOTALE AGEVOLATO

      var totAccess = parseFloat(
        this.totalAccessories.replace(".", "").replace(",", ".")
      ).toFixed(2); // TOTALE ACCESSORI
      var workPrice = parseFloat(
        this.priceWork.replace(".", "").replace(",", ".")
      ).toFixed(2); // MANODOPERA

      var totAltroAcc = (parseFloat(totAccess) + parseFloat(workPrice)).toFixed(
        2
      );
      //var totAltroAcc = ( parseFloat(workPrice) ).toFixed(2)

      // if totProducts > totAltroAcc = altroAcc
      // else totProducts
      if (parseFloat(totAge) > parseFloat(totAltroAcc)) {
        var x10 = totAltroAcc;
        var x22 = totAge - totAltroAcc;
      } else {
        var x10 = totAge;
        var x22 = 0;
      }

      this.age_lavoro = x10;
      this.age_extra = x22;

      var ratio10 = (parseFloat(x10) / parseFloat(totProducts)).toFixed(5);
      var ratio22 = (parseFloat(x22) / parseFloat(totProducts)).toFixed(5);

      var enea = 50;
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,
      */
      // TOTAL BASE
      //this.calcInfo.totalBase = parseFloat(totProducts) + parseFloat(totAccess) + parseFloat(workPrice) - parseFloat(totalExtraMise)
      this.calcInfo.totalBase = (
        parseFloat(totAge) + parseFloat(totAltroAcc)
      ).toFixed(2);

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.iva10Age = (
          parseFloat(totAltroAcc) * this.iva_accessori_lavoro +
          parseFloat(totAge) * this.iva_age_lavoro
        ).toFixed(2);
        //this.calcInfo.iva10NonAge = ((((parseFloat(totalExtraMise) )) * this.iva_altri_oneri)).toFixed(2)
        this.calcInfo.iva10NonAge = 0;

        //this.calcInfo.iva22Age = ((((parseFloat(totAge) )) * this.iva_age_extra )).toFixed(2)
        this.calcInfo.iva22Age = (
          parseFloat(this.age_extra) * this.iva_age_extra
        ).toFixed(2);
        this.calcInfo.iva22NonAge = (
          parseFloat(totalExtraMise) * this.iva_altri_oneri
        ).toFixed(2);
      } else {
        this.calcInfo.iva10Age = 0;
        this.calcInfo.iva10NonAge = 0;

        this.calcInfo.iva22Age = 0;
        this.calcInfo.iva22NonAge = 0;
      }

      this.$log("totProducts " + totProducts);
      this.$log("totalExtraMise " + totalExtraMise);
      this.$log("totAccess " + totAccess);
      this.$log("workPrice " + workPrice);
      this.$log("totAltroAcc " + totAltroAcc);
      this.$log("totAge " + totAge);
      this.$log("totalExtraMise " + totalExtraMise);

      this.$log("x10 " + x10);
      this.$log("x22 " + x22);
      this.$log("ratio10 " + ratio10);
      this.$log("ratio22 " + ratio22);
      this.$log(this.calcInfo);

      // IVA 10
      //if ((parseFloat(totProducts) - parseFloat(totalExtraMise) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
      /*if ((parseFloat(totProducts) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + ((parseFloat(totAccess) + parseFloat(workPrice)))) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)

        // IVA 22
        //this.calcInfo.iva22 = ((parseFloat(totProducts) - parseFloat(totalExtraMise)) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = ( (parseFloat(totProducts) ) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)

      } else {

        //this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) - parseFloat(totalExtraMise))) / 100 * 10
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) )) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)

        // IVA 22
        this.calcInfo.iva22 = 0
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)

      }*/

      this.$log("totalBase - " + this.calcInfo.totalBase);

      var temp = this.iva_age_extra;

      if (this.getProfile.reg_forfettario == "si") {
        this.iva_accessori_lavoro = 0.0;
        this.iva_age_lavoro = 0.0;
        this.iva_age_accessori = 0.0;
        temp = 0.0;
      }

      this.$log("age_lavoro - " + this.age_lavoro);
      this.$log("iva_age_lavoro - " + this.iva_age_lavoro);
      this.$log("age_extra - " + this.age_extra);
      this.$log("iva_age_extra - " + this.iva_age_extra);
      this.$log("totAltroAcc - " + totAltroAcc);
      this.$log("totAltroAcc - " + this.iva_accessori_lavoro);

      //TOTAL BASE AND IVA 10 && 22
      //this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBase) + parseFloat(this.calcInfo.iva10Age) + parseFloat(this.calcInfo.iva22Age)
      this.calcInfo.totalBaseAndIva =
        parseFloat(this.age_lavoro) * (1 + parseFloat(this.iva_age_lavoro)) +
        parseFloat(this.age_extra) * (1 + parseFloat(temp)) +
        parseFloat(totAltroAcc) * (1 + parseFloat(this.iva_accessori_lavoro));

      this.calcInfo.totalBaseAndIva = parseFloat(
        this.calcInfo.totalBaseAndIva
      ).toFixed(2);

      // TOTALE DETRAZIONE
      if (
        this.ecoBonus != "Bonus Casa 50%" &&
        this.client_type == "Partita IVA" &&
        this.usoAbitativo == 0 &&
        this.iva_age_lavoro == "0.22" &&
        this.iva_age_extra == "0.22" &&
        this.iva_accessori_lavoro == "0.22"
      ) {
        this.calcInfo.totalWithBonus =
          (parseFloat(this.calcInfo.totalBase) / 100) *
          parseFloat(percentbonusDetr);
      } else {
        this.calcInfo.totalWithBonus =
          (parseFloat(this.calcInfo.totalBaseAndIva) / 100) *
          parseFloat(percentbonusDetr);
      }
      this.calcInfo.totalWithBonus = parseFloat(
        this.calcInfo.totalWithBonus
      ).toFixed(2);

      this.calcInfo.total35 =
        (parseFloat(this.calcInfo.totalBaseAndIva) / 100) *
        parseFloat(percentToPay);
      this.calcInfo.total35 = parseFloat(this.calcInfo.total35).toFixed(2);

      if (display != "nopopup") {
        this.calcInfo.costoAttualizazione =
          (parseFloat(this.calcInfo.totalWithBonus) / 100) * AttPercent;
        this.calcInfo.costoAttualizazione = parseFloat(
          this.calcInfo.costoAttualizazione
        ).toFixed(2);
      }

      this.calcInfo.allOneri =
        parseFloat(this.calcInfo.costoAttualizazione) +
        parseFloat(this.calcInfo.serviceCost) +
        parseFloat(this.calcInfo.serviceCost) * this.iva_altri_oneri;
      this.calcInfo.allOneri = parseFloat(this.calcInfo.allOneri).toFixed(2);

      if (this.datiCatastali) {
        var dCast =
          process.env.PRICE_DCAST * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dCast = 0;
      }

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.finalPrice = (
          parseFloat(this.calcInfo.totalBaseAndIva) -
          parseFloat(this.calcInfo.totalWithBonus) +
          (parseFloat(totalExtraMise) +
            parseFloat(this.calcInfo.iva22NonAge) +
            parseFloat(this.calcInfo.iva10NonAge) +
            parseFloat(this.priceEnea.replace(".", "").replace(",", ".")) *
              (parseFloat(this.iva_altri_oneri) + 1) +
            parseFloat(this.priceDcast) *
              (parseFloat(this.iva_altri_oneri) + 1) +
            parseFloat(this.calcInfo.allOneri))
        ).toFixed(2);
      } else {
        this.calcInfo.finalPrice = (
          parseFloat(this.calcInfo.totalBaseAndIva) -
          parseFloat(this.calcInfo.totalWithBonus) +
          (parseFloat(totalExtraMise) +
            parseFloat(this.calcInfo.iva22NonAge) +
            parseFloat(this.calcInfo.iva10NonAge) +
            parseFloat(this.priceEnea.replace(".", "").replace(",", ".")) +
            parseFloat(this.priceDcast) +
            parseFloat(this.calcInfo.allOneri))
        ).toFixed(2);
      }
      //this.calcInfo.finalPrice = ( ( parseFloat(this.calcInfo.totalBaseAndIva) -  parseFloat(this.calcInfo.totalWithBonus) ) + (( parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) +  parseFloat(this.calcInfo.iva10NonAge) ) + ( parseFloat(this.priceEnea) * 1.22 ) + parseFloat(dCast) + (parseFloat(this.calcInfo.costoAttualizazione) ) )).toFixed(2)

      //this.calcInfo.finalPrice =  (parseFloat(this.calcInfo.total35) - ( parseFloat(this.calcInfo.costoAttualizazione) )).toFixed(2)

      if (this.enea) {
        var dEnea =
          process.env.PRICE_ENEA * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dEnea = 0;
      }

      // INSTALALTORE
      this.calcInfo.aInstallatore = (
        parseFloat(this.calcInfo.totalWithBonus) -
        parseFloat(this.calcInfo.costoAttualizazione) -
        dEnea -
        dCast
      ).toFixed(2);

      this.calcInfo.finalPrice = parseFloat(this.calcInfo.finalPrice).toFixed(
        2
      );
      this.$log(this.calcInfo);

      // CHECK IF TOTAL PRICE NOT OVER
      var totalDiscount = this.calcInfo.totalWithBonus;

      // BONUS CASA 50  ************************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%" && display != "nopopup") {
        // MAX DETRAZIONE 96000 FOR ALL
        if (totalDiscount > 96000) {
          var alert = {};
          alert.text =
            "Bonus Casa 50% prevede una detrazione massima ammissibile di 96.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text,
          });
        }
      }
      // END BONUS CASA 50  ********************************************************************************************************************

      // ECO BONUS 50  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%" && display != "nopopup") {
        //i. SOLO la sostituzione, integrale o parziale, di impianti di climatizzazione invernale con impianti dotati di caldaie a condensazione
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text =
            "Ecobonus 50% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text,
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE
        var presentValv = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
            }
          }
        }
        if (!presentValv) {
          var alert = {};
          alert.text =
            "Ecobonus 50% prevede Installazione valvole termostatiche salvo impianti a bassa temperatura (T media < 45°C) o impossibilità tecnica";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text,
          });
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%" && display != "nopopup") {
        //c) interventi di installazione di collettori solari di cui all’art. 1, comma 346, della legge 27 dicembre 2006, n. 296 per la produzione
        // di acqua calda per usi domestici o industriali e per la copertura del fabbisogno di acqua calda in piscine, strutture sportive, case di
        //ricovero e cura,istituti scolastici e università
        if (totalDiscount > 60000) {
          var alert = {};
          alert.text =
            "Ecobonus 65% prevede una detrazione massima ammissibile di 60.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text,
          });
        }

        // ii. i medesimi interventi di cui al punto i, con la contestuale installazione di sistemi di termoregolazione
        // evoluti, appartenenti alle classi V, VI oppure VIII della comunicazione della Commissione 2014/C 207/02;
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text =
            "Ecobonus 65% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text,
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE AND TERMOREGOLAZIONE
        var presentValv = false;
        var presentTerm = false;

        var haveCondensed = false;

        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            haveCondensed = true;
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
              if (this.accessories[y].group == "termoregolazione") {
                presentTerm = true;
              }
            }
          }
        }

        if (!presentValv || !presentTerm) {
          if (haveCondensed) {
            var alert = {};
            alert.text =
              "Ecobonus 65% prevede Installazione valvole termostatiche e dispositivo di controllo della temperatura che deve appartenere alle classi V, VI oppure VIII";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(ADD_NOTIFICATIONS, alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text,
            });
          }
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  ***********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%" && display != "nopopup") {
      }
      // END SUPERBONUS 110   ******************************************************************************************************************

      this.calcFinish = true;
    },

    // ADD REMOVE ITEMS ***************************************************************
    addProduct() {
      this.productIndex = this.productIndex + 1;
      this.products.push({
        index: "product" + this.productIndex,
        indexCount: "quantity" + this.productIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false,
      });
    },
    removeProduct(elem) {
      this.productIndex = this.productIndex - 1;
      var index = this.products.indexOf(elem);
      this.products.splice(elem, 1);
      this.calcTotalPriceProducts();
    },
    addAccessories() {
      this.accessoriesIndex = this.accessoriesIndex + 1;
      this.accessories.push({
        index: "product" + this.accessoriesIndex,
        indexCount: "quantity" + this.accessoriesIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false,
      });
    },
    removeAccessories(elem) {
      this.accessoriesIndex = this.accessoriesIndex - 1;
      var index = this.accessories.indexOf(elem);
      this.accessories.splice(elem, 1);
      this.calcTotalPriceAccessories();
    },

    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    },
    handleResize: function () {
      this.vw = window.innerWidth;
      var h = window.innerHeight;

      if (this.vw > 1200 && h > 800) {
        this.stepSize = "md";
      } else {
        this.stepSize = "sm";
      }
    },
    // PRELOAD LOCATIONS ***************************************************************
    populateProvincies: function () {
      const { provincies, provinciesState } = this;
      axios({
        url: process.env.ROOT_API + "api/getProvinciesAll",
        method: "POST",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.provincies = resp.data.provincies;
          this.provinciesState = false;
        })
        .catch((resp) => {
          this.provincies = [];
          this.provinciesState = false;
        });
    },
    checkProvince: function () {
      const { province } = this;
      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function () {
      const { city } = this;
      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    calcToDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() - 1));
      var finalTo = date;

      this.$log(finalTo);
      return finalTo;
    },
    calcFromDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() + 1000));
      var finalTo = date;
      return finalTo;
    },
    formatpriceWork() {
      this.priceWork = numeral(this.priceWork).format("0.0,[00]");
    },
    formatpriceEnea() {
      this.priceEnea = numeral(this.priceEnea).format("0.0,[00]");
    },
    formatpriceDcast() {
      this.priceDcast = numeral(this.priceDcast).format("0.0,[00]");
    },

    // PRODUCTS ***************************************************************
    loadProducts() {
      if(this.corporateClient){
        var data = {
        key: "calc",
        cc : this.corporateClient
      }
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      axios({
        url: process.env.ROOT_API + "api/getProducts",
        method: "POST",
        data: {
          data
        },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.allProducts = resp.data.allProducts;
          this.$log(this.allProducts);
        })
        .catch((resp) => {});
      }else{
        this.setProfile()
      }
      
    },
    setProfile: function () {
      //type 1 => no preventivatore
      this.corporateClient = this.getProfile.corporateClient;
      if(this.corporateClient) this.loadProducts()

    },
    setGroup(index) {
      var i = index.slice(7, index.length);
      this.items[index] = this.allProducts[this.products[i].group];
      this.products[i].product = {
        index: "",
        name: "",
        serial: "",
      };
      this.products[i].price = "";
      this.products[i].kw = "";
      this.products[i].quantity = "";
      this.$log(this.items);
      this.calcTotalPriceProducts();
    },
    formatPrice(index) {
      var i = index.slice(7, index.length);
      this.products[i].price = numeral(this.products[i].price).format(
        "0.0,[00]"
      );
      // CALC MAX POSSIBLE PRICE FOR PRODUCT BY kW
      this.calcMaxPriceByKW(index);
    },
    setProduct(index) {
      var i = index.slice(7, index.length);
      if (this.products[i].group != "ibridi") {
        if (this.products[i].group != "altroVaillant") {
          this.products[i].kw =
            this.allProducts[this.products[i].group][
              this.products[i].product.index
            ].Potenza;
          //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
          this.products[i].quantity = 1;
        } else {
          //this.products[i].product = {'index': 100 + i, 'name': this.products[i].product, 'serial': ''}
          this.products[i].quantity = 1;
        }
      } else {
        //var kw = (parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaCaldaiaCondensazione) + parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore)).toFixed(2)
        var kw = parseFloat(
          this.allProducts[this.products[i].group][
            this.products[i].product.index
          ].PotenzaPompadiCalore
        ).toFixed(2);
        this.products[i].kw = kw;
        //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
        this.products[i].quantity = 1;

        // LOAD 2 PRODUCT FROM IS COMPOST IBRIDE SYSTEM
        var condensazione =
          this.allProducts[this.products[i].group][
            this.products[i].product.index
          ].ModelloCaldaiaACondensazione;
        var pompadicalore =
          this.allProducts[this.products[i].group][
            this.products[i].product.index
          ].ModelloPompaDiCalore;

        var condensazioneSearch = false;
        var pompadicaloreSearch = false;
        // SEARCH CONDENS
        for (var x in this.allProducts["condensazione"]) {
          if (
            this.allProducts["condensazione"][x].Modello.includes(condensazione)
          ) {
            condensazioneSearch = this.allProducts["condensazione"][x];
          }
        }
        // SEARCH POMPA DI CALORE
        for (var x in this.allProducts["pompadicalore"]) {
          if (
            this.allProducts["pompadicalore"][x].Modello.includes(pompadicalore)
          ) {
            pompadicaloreSearch = this.allProducts["pompadicalore"][x];
          }
        }
      }
      this.calcTotalPriceProducts();
      // CHECK ALL RULES OF BONUS
      this.checkProductWithBonusRules(index);
    },
    checkProductWithBonusRules(index) {
      var i = index.slice(7, index.length);
      this.$log("FUNCTION => checkProductWithBonusRules");
      this.$log("BONUS SELECTED => " + this.ecoBonus);

      this.requiredOperations = "";

      // BONUS CASA *********************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%") {
        // CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE
        this.$warn("CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE");
        if (
          this.products[i].group == "pompadicalore" &&
          (this.province == "AL" ||
            this.province == "AT" ||
            this.province == "BI" ||
            this.province == "CN" ||
            this.province == "NO" ||
            this.province == "TO" ||
            this.province == "VB" ||
            this.province == "VC")
        ) {
          var canUseInPiemonte =
            this.allProducts[this.products[i].group][
              this.products[i].product.index
            ].Piemonte;
          this.$warn(
            "GROUP => pompadicalore AND REGION PIEMONTE => RESULT CAN USE: " +
              canUseInPiemonte
          );
          if (canUseInPiemonte == "no") {
            var alert = {};
            alert.text =
              "La pompa di calore selezionata risulta non installabile nella regione Piemonte";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(ADD_NOTIFICATIONS, alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text,
            });
          }
        }
        // SET requiredOperations
        if (
          this.products[i].group == "pompadicalore" ||
          this.products[i].group == "condensazione" ||
          this.products[i].group == "ibridi" ||
          this.products[i].group == "tradizionale"
        ) {
          this.requiredOperations =
            "Trattamento acqua UNI 8065 Prospetti 9 e 11";
        }
        // SET requiredOperations
        if (this.products[i].group == "solare") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 15";
        }
        // SET requiredOperations
        if (this.products[i].group == "scaldacqua") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 12";
        }

        // NO ENEA
        if (this.products[i].group == "tradizionale") {
          this.NoEnea = true;
          this.priceEnea = "0";
          this.enea = 0;
        } else {
          this.NoEnea = true;
        }
      } else {
        this.$warn("CHECK POMPE DI CALORE USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "pompadicalore") {
          var onlyBonusCasa =
            this.allProducts[this.products[i].group][
              this.products[i].product.index
            ].onlyBonusCasa;
          this.$warn(
            "GROUP => pompadicalore AND onlyBonusCasa: " + onlyBonusCasa
          );
          if (onlyBonusCasa == "yes") {
            var alert = {};
            alert.text =
              "La Pompa di calore selezionata risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(ADD_NOTIFICATIONS, alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text,
            });
          }
        }
      }
      // END BONUS CASA *********************************************************************************************************************

      // ECO BONUS 50  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%") {
        if (
          this.products[i].group != "condensazione" &&
          this.products[i].group != "ibridi" &&
          this.products[i].group != "solare" &&
          this.products[i].group != ""
        ) {
          var alert = {};
          alert.text =
            "Per Ecobonus 50% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text,
          });
        } else {
          this.requiredOperations =
            " - Trattamento acqua UNI 8065 Prospetti 9 e 11 <br/>";
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%") {
        /*if (this.products[i].group != 'condensazione' && this.products[i].group != 'ibridi' && this.products[i].group != 'solare' && this.products[i].group != '') {
          var alert = {}
          alert.text = 'Per Ecobonus 65% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi'
          alert.type = 'ERROR'
          this.$warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }*/
        // FOR CONDENSAZIONE
        if (this.products[i].group == "condensazione") {
          this.requiredOperations =
            " - Trattamento acqua UNI 8065 Prospetti 9 e 11 ";
        }
        // FOR SOLARI
        if (this.products[i].group == "solare") {
          this.requiredOperations =
            " - Trattamento acqua UNI 8065 Prospetto 15";
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  *********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%") {
      }
      // END SUPERBONUS 110   *********************************************************************************************************************

      // CHECK EVENT TYPE  *********************************************************************************************************************
      /*if (this.eventType == 'Instalazione') {
        if (this.products[i].group == 'condensazione' || this.products[i].group == 'tradizionale' || this.products[i].group == 'pompadicalore' || this.products[i].group == 'ibridi' || this.products[i].group == 'scaldacqua') {
          var alert = {}
          alert.text = 'Per ' + this.ecoBonus + ' con tipo di intervento selezionato aderiscono soltanto le Climatizzatori e Collettori solari'
          alert.type = 'ERROR'
          this.$warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }
      }*/
      // END EVENT TYPE  *********************************************************************************************************************

      // NEWWWW REVIEW POPUPS

      if (
        this.eventType == "Instalazione" &&
        this.ecoBonus == "Bonus Casa 50%"
      ) {
        if (this.products[i].group != "solare") {
          this.warning1();
        }
      }

      if (this.eventType == "Instalazione" && this.ecoBonus == "Ecobonus 50%") {
        if (this.products[i].group == "condensazione") {
          this.warning2();
        }
      }

      if (this.eventType == "Instalazione" && this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group != "solare") {
          this.warning15();
        }
      }

      if (this.eventType != "Instalazione" && this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group == "climatizzatore") {
          this.warning16();
        }
      }

      if (this.ecoBonus != "Bonus Casa 50%") {
        this.$warn("CHECK climatizzatore USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "climatizzatore") {
          var onlyBonusCasa =
            this.allProducts[this.products[i].group][
              this.products[i].product.index
            ].onlyBonusCasa;
          this.$warn(
            "GROUP => climatizzatore AND onlyBonusCasa: " + onlyBonusCasa
          );
          if (onlyBonusCasa == "yes") {
            this.warning162();
          }
        }
      }
    },
    warning162() {
      var _vue = this;
      var alert = {};
      this.$log("INSIDE 162");
      alert.text =
        "Il climatizzatore selezionato risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
      alert.type = "ERROR";
      setTimeout(function () {
        _vue.$swal({
          type: "error",
          title: "ATTENZIONE",
          html: alert.text,
        });
      }, 1000);
      this.$store.dispatch(ADD_NOTIFICATIONS, alert);
    },
    warning16() {
      var alert = {};
      alert.text =
        "Con Ecobonus 65% la sostituzione di un climatizzatore è ammessa solo se si tratta dell`unico generatore di calore";
      alert.type = "ERROR";
      this.$store.dispatch(ADD_NOTIFICATIONS, alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text,
      });
    },
    warning15() {
      var alert = {};
      alert.text =
        "Con Ecobonus 65% la nuova installazione è consentita solo per Collettori Solari.";
      alert.type = "ERROR";
      this.$store.dispatch(ADD_NOTIFICATIONS, alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text,
      });
    },
    warning2() {
      var alert = {};
      alert.text =
        "Con Ecobonus 50% non è consentita la nuova installazione di apparecchi";
      alert.type = "ERROR";
      this.$store.dispatch(ADD_NOTIFICATIONS, alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text,
      });
    },
    warning1() {
      var alert = {};
      alert.text =
        "Con il BonusCasa 50% la nuova installazione è consentita solo per i Collettori Solari. È ammessa la nuova installazione anche di Climatizzatori e Pompe di Calore ma solo se l`impianto termico è esistente";
      alert.type = "ERROR";
      this.$store.dispatch(ADD_NOTIFICATIONS, alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text,
      });
    },

    insertProductCode(input) {
      var i = input.slice(7, input.length);
      this.$log(i);
      var _vue = this;
      this.$swal({
        title: "Inserisci codice prodotto",
        input: "text",
        text: "esempio: 0010014674",
        inputAttributes: {
          autocapitalize: "on",
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: async (searchItem) => {
          var result = await this.searchProduct(searchItem, i, input);
          var length = searchItem.length;

          if (length != 10) {
            this.$swal.showValidationMessage(
              `Codice Prodotto ${"deve essere composto da 10 caratteri"}`
            );
            return false;
          }

          if (result) {
            _vue.checkProductWithBonusRules(input);
            return result;
          } else {
            //throw new Error('Prodotto non trovato')
            this.$swal.showValidationMessage(` ${"Prodotto non trovato"}`);
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        this.calcTotalPriceProducts();
      });
    },
    async searchProduct(searchItem, index, input) {
      var data = this.allProducts;
      for (var x in data) {
        for (var y in data[x]) {
          if (data[x][y].codice.includes(searchItem)) {
            //0010014674
            this.items[input] = this.allProducts[x];

            this.products[index].group = x;
            var z = {
              index: y,
              name: data[x][y].Modello,
              serial: data[x][y].codice,
            };
            this.products[index].product = z;
            this.products[index].quantity = 1;
            //this.products[index].price = data[x][y].prezzo

            return data[x][y];
          }
        }
      }
    },
    calcTotalPriceProducts() {
      var price = 0;
      this.totalExtraMise = 0;

      for (var x in this.products) {
        price +=
          this.products[x].quantity *
          parseFloat(
            this.products[x].price.replace(".", "").replace(",", ".")
          ).toFixed(2);
        if (this.products[x].extraMise) {
          this.totalExtraMise =
            parseFloat(this.totalExtraMise) +
            parseFloat(this.products[x].extraMise);
        }
      }
      if (price) {
        this.totalProducts = numeral(price).format("0.0,[00]");
      } else {
        this.totalProducts = "0,00";
      }

      this.totalExtraMise = this.totalExtraMise.toFixed(2);

      if (this.ecoBonus == "Bonus Casa 50%") {
        this.totalExtraMise = parseFloat(0).toFixed(2);
        this.clearExtraMise = true;
      } else {
        this.clearExtraMise = false;
      }

      this.$log(
        "TOTAL EXTRA MISE ***************************************" +
          this.totalExtraMise
      );

      this.$log(this.products);
    },
    calcMaxPriceByKW(index) {
      var i = index.slice(7, index.length);
      var price = this.products[i].price;
      var error = false;
      var errorType = false;

      this.products[i].extraMise = 0;

      if (this.products[i].product && price) {
        // NEW POMPE DI CALORE
        if (this.products[i].group == "climatizzatore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(
              2
            );
            var res = (
              parseFloat(price) / parseFloat(kw.replace(",", "."))
            ).toFixed(2);
            if (res > 600) {
              error = "600";
              errorType = "kw";
              this.products[i].extraMise = (
                parseFloat(price) -
                parseFloat(kw.replace(",", ".")) * 600
              ).toFixed(2);
            }
          }
        }

        // NEW POMPE DI CALORE
        if (this.products[i].group == "pompadicalore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(
              2
            );
            var res = (
              parseFloat(price) / parseFloat(kw.replace(",", "."))
            ).toFixed(2);
            if (
              res > 1300 &&
              !this.products[i].product.name.includes("flexo")
            ) {
              error = "1300";
              errorType = "kw";
              this.products[i].extraMise = (
                parseFloat(price) -
                parseFloat(kw.replace(",", ".")) * 1300
              ).toFixed(2);
            }
            if (res > 1900 && this.products[i].product.name.includes("flexo")) {
              error = "1900";
              errorType = "kw";
              this.products[i].extraMise = (
                parseFloat(price) -
                parseFloat(kw.replace(",", ".")) * 1900
              ).toFixed(2);
            }
          }
        }

        // CALDAIE POWER > 35 kW || <= 35 kW
        if (
          this.products[i].group == "condensazione" ||
          this.products[i].group == "tradizionale"
        ) {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(
              2
            );
            var res = (
              parseFloat(price) / parseFloat(kw.replace(",", "."))
            ).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (kw <= 35 && res > 200) {
              error = "200";
              errorType = "kw";
              this.products[i].extraMise = (
                parseFloat(price) -
                parseFloat(kw.replace(",", ".")) * 200
              ).toFixed(2);
            } else if (kw > 35 && res > 180) {
              error = "180";
              errorType = "kw";

              this.$log(price);
              this.$log(kw);
              this.products[i].extraMise = (
                parseFloat(price) -
                parseFloat(kw.replace(",", ".")) * 180
              ).toFixed(2);
            }
          }
        }

        // SOLARE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "solare") {
          price = parseFloat(price.replace(".", "")).toFixed(2);
          var type =
            this.allProducts[this.products[i].group][
              this.products[i].product.index
            ].tipologia;
          var superfice = parseFloat(
            this.allProducts[this.products[i].group][
              this.products[i].product.index
            ].superficielorda.replace(",", ".")
          ).toFixed(2);
          var res = (parseFloat(price) / parseFloat(superfice)).toFixed(2);

          this.$log("superfice " + superfice);

          this.$log("res " + res);

          // IF PIANI max price for 1 m2 of power is 1000 Euro
          // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
          if (type == "Piani" && res > 1000) {
            error = "1000";
            errorType = "m2";
            this.products[i].extraMise = (
              parseFloat(price) -
              parseFloat(superfice) * 1000
            ).toFixed(2);
          } else if (type == "Sottovuoto" && res > 1250) {
            error = "1250";
            errorType = "m2";
            this.products[i].extraMise = (
              parseFloat(price) -
              parseFloat(superfice) * 1250
            ).toFixed(2);
          }
        }

        // SCALDAACQUA POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "scaldacqua") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var type = this.allProducts[this.products[i].group][
              this.products[i].product.index
            ].capacita.replace(",", ".");
            //var superfice = parseFloat(this.products[i].superficielorda).toFixed(2)
            var res = (parseFloat(price) / parseFloat(type)).toFixed(2);

            // IF PIANI max price for 1 m2 of power is 1000 Euro
            // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
            if (parseInt(type) <= 150 && price > 1000) {
              error = "1000";
              errorType = "lt1";
              this.products[i].extraMise = (parseFloat(price) - 1000).toFixed(
                2
              );
            } else if (parseInt(type) > 150 && price > 1250) {
              error = "1250";
              errorType = "lt2";
              this.products[i].extraMise = (parseFloat(price) - 1250).toFixed(
                2
              );
            }
          }

          //'climatizzatore'
        }

        // 'ibridi'
        // IBRIDE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "ibridi") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = this.products[i].kw.replace(",", ".");
            var res = (parseFloat(price) / parseFloat(kw)).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (res > 1550) {
              error = "1550";
              errorType = "kw";
              this.products[i].extraMise = (
                parseFloat(price) -
                parseFloat(kw) * 1550
              ).toFixed(2);
            }
          }
        }
      }

      // SHOW POP UP IF ERROR
      if (error) {
        // Use sweetalret2

        var alert = {};

        if (errorType == "kw") {
          alert.text =
            "Il prezzo da te indicato supera il valore massimale MISE </br> €" +
            error +
            "/kW di potenza nominale. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "m2") {
          alert.text =
            "Il prezzo da te indicato supera il valore massimale MISE </br> €" +
            error +
            "/m<sup>2</sup> installato. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt1") {
          alert.text =
            "Il prezzo da te indicato supera il valore massimale MISE </br> €" +
            error +
            " fino a 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt2") {
          alert.text =
            "Il prezzo da te indicato supera il valore massimale MISE </br> €" +
            error +
            " oltre 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (this.ecoBonus != "Bonus Casa 50%") {
          alert.type = "ERROR";
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text,
          });
        }
      }
    },

    // ----------------- ACCESSORIES ----------------------------------------
    calcTotalPriceAccessories() {
      var price = 0;
      for (var x in this.accessories) {
        price +=
          this.accessories[x].quantity *
          parseFloat(
            this.accessories[x].price.replace(".", "").replace(",", ".")
          ).toFixed(2);
      }
      if (price) {
        this.totalAccessories = numeral(price).format("0.0,[00]");
      } else {
        this.totalAccessories = "0,00";
      }
    },
    setTypeAccessories(index) {
      var i = index.slice(7, index.length);
      this.itemsAccessories[index] =
        this.allProducts[this.accessories[i].group];
      var x = this.itemsAccessories[index];
      if (
        x != "condensazione" &&
        x != "tradizionale" &&
        x != "pompadicalore" &&
        x != "scaldacqua" &&
        x != "climatizzatore" &&
        x != "solare" &&
        x != "termoregolazione"
      ) {
        var z = {
          index: i,
          name: "",
          serial: "",
        };
        this.accessories[i].product = z;
        this.accessories[i].price = "";
        this.accessories[i].quantity = "";
      }
      this.calcTotalPriceAccessories();
    },
    formatPriceAccessories(index) {
      var i = index.slice(7, index.length);
      this.accessories[i].price = numeral(this.accessories[i].price).format(
        "0.0,[00]"
      );
      //this.accessories[i].price = this.accessories[i].price.replace(/\D+/g, '');
    },
    setAccessories(index) {
      var i = index.slice(7, index.length);
      var x = this.accessories[i].group;
      this.accessories[i].kw =
        this.allProducts[this.accessories[i].group][
          this.accessories[i].product.index
        ].Potenza;
      //this.accessories[i].price = (this.allProducts[this.accessories[i].group][this.accessories[i].product.index].prezzo).replace(' ', '').replace('€', '')
      this.formatPriceAccessories(index);
      this.accessories[i].quantity = 1;
      this.calcTotalPriceAccessories();

      // CONTROL IF PRESENT ALL RULES
      this.checkAccessoriesWithBonusRules(index);
    },
    checkAccessoriesWithBonusRules(index) {
      var i = index.slice(7, index.length);
      var group = this.accessories[i].group;

      if (
        this.ecoBonus == "Ecobonus 50%" ||
        this.ecoBonus == "Bonus Casa 50%"
      ) {
        // IF PRESENT TERMOREGOLAZIONE && CONDENSAZIONE => CAN GET BONUS 65%
        var presentCondenset = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            presentCondenset = true;
          }
        }
        if (group == "termoregolazione" && presentCondenset) {
          var alert = {};
          alert.text =
            "Con caldaia a condensazione, valvole termostatiche e centraline termoregolazione evoluta puoi aderire all`Ecobonus 65%";
          alert.type = "NOTIFICATION";
          this.$warn(alert.text);
          this.$store.dispatch(ADD_NOTIFICATIONS, alert);
          this.$swal({
            type: "info",
            title: "ATTENZIONE",
            html: alert.text,
          });
        }
      }
    },
    insertAccessoriesCode(input) {
      var i = input.slice(7, input.length);
      this.$log(i);

      this.$swal({
        title: "Inserisci il codice accessorio",
        input: "text",
        text: "esempio: 0020124480",
        inputAttributes: {
          autocapitalize: "on",
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: async (searchItem) => {
          var result = await this.searchAccessories(searchItem, i, input);
          var length = searchItem.length;

          if (length != 10) {
            this.$swal.showValidationMessage(
              `Codice Accessorio ${"deve essere composto da 10 caratteri"}`
            );
            return false;
          }

          if (result) {
            return result;
          } else {
            //throw new Error('Prodotto non trovato')
            this.$swal.showValidationMessage(` ${"Accessorio non trovato"}`);
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        this.calcTotalPriceAccessories();
      });
    },
    async searchAccessories(searchItem, index, input) {
      var data = this.allProducts;
      for (var x in data) {
        if (
          x != "condensazione" &&
          x != "tradizionale" &&
          x != "pompadicalore" &&
          x != "scaldacqua" &&
          x != "climatizzatore" &&
          x != "solare"
        ) {
          for (var y in data[x]) {
            if (data[x][y].codice == searchItem) {
              //0010014674
              this.itemsAccessories[input] = this.allProducts[x];
              this.accessories[index].group = x;
              var z = {
                index: y,
                name: data[x][y].Modello,
                serial: data[x][y].codice,
              };
              this.accessories[index].product = z;
              this.accessories[index].quantity = 1;
              //this.accessories[index].price = data[x][y].prezzo

              this.$log(this.accessories);

              return data[x][y];
            }
          }
        }
      }
    },
    mynotifications() {
      return this.getNotifications;
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    },
    calcIvaCustom(val) {
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,*/

      if (val == "Partita IVA") {
        this.iva_accessori_lavoro = 0.22;
        this.iva_age_lavoro = 0.22;
        this.iva_age_accessori = 0.22;
      } else {
        if (this.usoAbitativo == 0) {
          this.iva_accessori_lavoro = 0.22;
          this.iva_age_lavoro = 0.22;
          this.iva_age_accessori = 0.22;
        } else {
          this.iva_accessori_lavoro = parseFloat(0.1).toFixed(2);
          this.iva_age_lavoro = parseFloat(0.1).toFixed(2);
          this.iva_age_accessori = parseFloat(0.1).toFixed(2);
        }
      }

      if (this.getProfile.reg_forfettario == "si") {
        this.iva_accessori_lavoro = 0.0;
        this.iva_age_lavoro = 0.0;
        this.iva_age_accessori = 0.0;
      }
    },
  },
  watch: {
    client_type: function (val) {
      this.calcIvaCustom(val);
    },
    usoAbitativo: function (val) {
      this.calcIvaCustom(this.client_type);
    },
    getProfile() {
      
      this.setProfile();
    },
    zeroEnea: function (val) {
      this.$log("1");
      if (val) {
        this.zeroEneaOld = this.priceEnea;
        this.priceEnea = "0";
      } else {
        this.priceEnea = this.zeroEneaOld;
      }
      this.beginCalc("nopopup");
    },
    zeroDcast: function (val) {
      this.$log("1");
      if (val) {
        this.zeroDcastOld = this.priceDcast;
        this.priceDcast = "0";
      } else {
        this.priceDcast = this.zeroDcastOld;
      }
      this.beginCalc("nopopup");
    },
    zeroOneri: function (val) {
      this.$log("2");
      if (val) {
        this.zeroOneriOld = this.calcInfo.costoAttualizazione;
        this.calcInfo.costoAttualizazione = 0;
      } else {
        this.calcInfo.costoAttualizazione = this.zeroOneriOld;
      }
      this.beginCalc("nopopup");
    },
    zeroPratica: function (val) {
      this.$log("3");
      if (val) {
        this.zeroPraticaOld = this.calcInfo.serviceCost;
        this.calcInfo.serviceCost = 0;
      } else {
        this.calcInfo.serviceCost = this.zeroPraticaOld;
      }
      this.beginCalc("nopopup");
    },
    products: {
      handler(val) {},
      deep: true,
    },
    priceWork: function (val) {
      this.priceWork = val.replace(
        /[a-bA-B`~!@#$£%^&*()_|+\-=?;:"<>\{\}\[\]\\\/]/gi,
        ""
      );
    },
    clientName: function (val) {
      if (val) {
        this.clientName = val.replace(/\d+/g, "");
        this.clientName = this.clientName.replace(
          /[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi,
          ""
        );
        this.clientName = this.clientName.toUpperCase();
      }
    },
    clientLastname: function (val) {
      if (val) {
        this.clientLastname = val.replace(/\d+/g, "");
        this.clientLastname = this.clientLastname.replace(
          /[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi,
          ""
        );
        this.clientLastname = this.clientLastname.toUpperCase();
      }
    },
    client_mobile: function (val) {
      if (val) {
        this.client_mobile = val.replace(/\D+/g, "");
      }
    },
    client_phone: function (val) {
      if (val) {
        this.client_phone = val.replace(/\D+/g, "");
      }
    },
    adress: function (val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function (val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    authStatus(value) {
      if (value == "not_confirmed") {
        this.confirmed = false;
      }
    },
    vw: function () {
      if (this.vw > 1200) {
        this.stepSize = "md";
      } else if (this.vw > 600) {
        this.stepSize = "sm";
      } else {
        this.stepSize = "xs";
      }
    },
    priceAcc(value) {
      // /this.priceAcc = parseInt(this.priceAcc) + '.00'
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function (newProvince) {
      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios({
          url: process.env.ROOT_API + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince,
          },
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.cities = resp.data.cities;
            this.citiesState = false;
          })
          .catch((resp) => {
            this.cities = [];
            this.citiesState = false;
          });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function (newCity) {
      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios({
          url: process.env.ROOT_API + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat,
          },
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.zips = resp.data.zips;
            this.zipsState = false;
          })
          .catch((resp) => {
            this.zips = [];
            this.zipsState = false;
          });
      }
    },
  },
  created() {
    this.setProfile();
    this.loadProducts();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.populateProvincies();
    this.setProfile();

    this.disabledDatesStart = {
      to: this.calcToDateStart(), // Disable all dates up to specific date
      from: this.calcFromDateStart(), // Disable all dates after specific date
    };

    this.$scrollTo("#app", 700, {
      offset: -75,
    });
  },
  computed: {
    ...mapGetters([
      "getNotifications",
      "getProfile",
      "loginerror",
      "isAuthenticated",
      "isProfileLoaded",
      "authStatus",
    ]),
    ...mapState({
      notifications: (state) => `${state.notifications}`,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/calcolatore/emicon.vue